
import { Optic_Map_op_HatPercent_Z1462312A, Optic_Set_op_HatEquals_Z32E30375, Optic_Map, Optic_Map_op_HatPercent_Z32F545AB, Optic_Set, Optic_Set_op_HatEquals_Z147477F8, Optic_Get_op_HatDot_Z146BA564, Compose_Lens, Compose_Lens_op_GreaterMinusGreater_Z15C92E89, Optic_Get, Optic_Get_op_HatDot_Z32FCD1E1, Compose_Prism, Compose_Prism_op_GreaterQmarkGreater_507FA136 } from "../Common/Optics.js";
import { Project, LoadedComponent, loadedComponents_, Component as Component_1, ComponentType, CustomComponentType, lcParameterDefs_ } from "../Common/CommonTypes.js";
import { topSheetChoiceDeclined_, notifications_, fromDiagram_, Model, projectOpt_, savedSheetIsOutOfDate_, Msg, sheet_, openLoadedComponentOfModel_ } from "../Model/ModelType.js";
import { isValidParamName, ParamDefinition, paramNamesOfExpr, paramNamesOfSlot, NewParamCompSpec, ParamBoxState, parseExpression, renderParamExpression, tryFindSlot, paramBoxKey, ParamSlot, removeSlot, addSlot, exprContainsParams, ParamName, CompSlotName, tryIntOfParamInt, slotsUsingParam, ConstrainedExpr, ParameterDefs, ParamConstraint, evaluateParamExpression, bindingsOf, ParamExpression, defaultBindings_, paramSlots_ } from "../Common/ParameterTypes.js";
import { exists as exists_2, tail, truncate, find, contains as contains_1, sumBy, forAll, zip, ofArray, empty as empty_2, length, filter as filter_1, cons, iterate, fold, mapIndexed, tryPick, ofSeq, head, map, append, isEmpty, singleton, choose, collect, tryFind } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { exists as exists_1, FSharpMap__get_IsEmpty, remove, count as count_1, filter as filter_2, map as map_2, toList as toList_1, containsKey, isEmpty as isEmpty_1, values, tryFind as tryFind_1, ofList, empty, add } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { fromOne, toString, compare as compare_1, fromZero } from "../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { toArray, value as value_10, orElse, defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { arrayHash, equalArrays, defaultOf, stringHash, safeHash, curry2, equals, comparePrimitives, compare } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { DrawModelType_SymbolT_Symbol, DrawModelType_SheetT_Msg, DrawModelType_BusWireT_Msg, DrawModelType_SymbolT_Msg, DrawModelType_SymbolT_symbols_, DrawModelType_BusWireT_symbol_, DrawModelType_SheetT_wire_ } from "../Model/DrawModelType.js";
import { printf, toFail, concat } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { Result_ToOption, Result_IsError, Result_Bind, FSharpResult$2 } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { simulationIsOpen, getUpdatedLoadedComponents, syncArrayTextOfOpenSheet, tryGetLoadedComponents } from "./ModelHelpers.js";
import { effectiveInstanceBindings, syncInstancePorts, signatureOfInstance, withPortWidths } from "../Simulator/CanvasExtractor.js";
import { shownValue, rootsContaining as rootsContaining_1, bindOfferForPlacement, findBindOffers, instanceBindingExprs, sheetsModifiedByOffer, projectDeclaresParams, effectiveTopSheetFor, displayValues as displayValues_1, bindParamOnInstances, propagateParameterValues, markSheetOutOfDate, sheetParamSlots } from "../Common/ParameterAnalysis.js";
import { trySetSlotValue, constraintsFor } from "../Common/ComponentSlots.js";
import { setTopSheetState, saveDirtyClosedSheets, extractLabelBase } from "./MenuHelpers.js";
import { exists, empty as empty_1, singleton as singleton_1, append as append_1, delay, toList, map as map_1, filter } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { DrawModelType_SheetT_Model__Model_ChangeJoinNum, DrawModelType_SheetT_Model__Model_ChangeInputValue, DrawModelType_SheetT_Model__Model_UpdateMemory, DrawModelType_SheetT_Model__Model_ChangeWidth, DrawModelType_SheetT_Model__Model_ChangeLSB, DrawModelType_SheetT_Model__Model_DoBusWidthInference_Z1E9EDA9D, DrawModelType_SheetT_Model__Model_ChangeSplitN, DrawModelType_SheetT_Model__Model_GetComponentById_72DDFA37 } from "../DrawBlock/Sheet.js";
import { warn } from "../Shared/Log.js";
import { List_groupBy, List_distinct, List_distinctBy } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { StringModule_Concat } from "../Common/EEExtensions.js";
import { errorPropsNotification, warningNotification, successPropertiesNotification } from "./Notifications.js";
import * as react from "react";
import { Confirm_usingParameters, Expressions_syntax, Expressions_title } from "../Common/AppMessages.js";
import { render } from "../Common/Markdown.js";
import { Option, div } from "../fable_modules/Fulma.3.0.0/Elements/Form/Field.fs.js";
import { Prop, DOMAttr, HTMLAttr } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { fieldLabel } from "./PropertiesHelp.js";
import { p as p_4, div as div_1 } from "../fable_modules/Fulma.3.0.0/Elements/Form/Control.fs.js";
import { input } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { Option as Option_1, IInputType } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { buildPopup, confirmationPopup, closablePopup, dialogPopupBodyDescriptionAndInt, getText2, getInt2, getText, dialogPopupBodyTextDescriptionAndInt, dialogPopup, preventDefault } from "../DrawBlock/PopupHelpers.js";
import { toString as toString_1 } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { getTextEventValue } from "../Interface/JSHelpers.js";
import { button, Option as Option_2, a as a_1 } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { add as add_1, contains, ofList as ofList_1 } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { helpText } from "./UIPopups.js";
import { Size_ISize, Color_IColor } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { label as label_1 } from "../fable_modules/Fulma.3.0.0/Elements/Form/Label.fs.js";
import { dataTooltip } from "../fable_modules/Fulma.Extensions.Wikiki.Tooltip.4.0.0/Tooltip.fs.js";
import { TableOption, table as table_10 } from "../fable_modules/Fulma.3.0.0/Elements/Table.fs.js";
import { item, right, left, Level_Option, level } from "../fable_modules/Fulma.3.0.0/Layouts/Level.fs.js";

export const lcParameterInfoOfModel_ = Compose_Prism_op_GreaterQmarkGreater_507FA136(Compose_Prism.Prism, lcParameterDefs_)(openLoadedComponentOfModel_);

export const paramSlotsOfModel_ = Compose_Prism_op_GreaterQmarkGreater_507FA136(Compose_Prism.Prism, paramSlots_)(lcParameterInfoOfModel_);

export const defaultBindingsOfModel_ = Compose_Prism_op_GreaterQmarkGreater_507FA136(Compose_Prism.Prism, defaultBindings_)(lcParameterInfoOfModel_);

/**
 * The open sheet's default bindings as an evaluation environment.
 * 
 * On an ARRAY DESIGN SHEET the loop variable is in scope too, at 0. It is not a declared property
 * of the sheet - it is named by the array settings and has a value only inside a copy, which is
 * why nothing else in the parameter system has to know about it: it is absent from
 * DefaultBindings, so the properties list does not show it, no instance binds it and propagation
 * never sees it. What it does need is to be in scope HERE, because using it is the whole point -
 * a Bus select whose LSB is `i` is what makes one copy of the sheet differ from the next. Zero is
 * the value the sheet is drawn at, so a box shows what copy 0 would have.
 * Bindings with the open sheet's loop variable added, at 0, when it is an array component.
 * 
 * Separate from paramBindingsOfModel because the environment is not always the sheet's declared
 * defaults: setting a property evaluates every slot against the value just typed, and doing that
 * without the loop variable skipped exactly the slots the array feature exists for.
 */
export function withLoopVariable(model, bindings) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const proj = matchValue;
        let _arg;
        const option_1 = tryFind((ldc) => (ldc.Name === proj.OpenFileName), proj.LoadedComponents);
        _arg = ((option_1 != null) ? option_1.ArrayInfo : undefined);
        if (_arg != null) {
            return add(_arg.LoopParam, new ParamExpression(/* PInt */ 0, [fromZero()]), bindings);
        }
        else {
            return bindings;
        }
    }
    else {
        return bindings;
    }
}

export function paramBindingsOfModel(model) {
    return withLoopVariable(model, bindingsOf(defaultArg(Optic_Get_op_HatDot_Z32FCD1E1(Optic_Get.Get, defaultBindingsOfModel_)(model), empty({
        Compare: (x, y) => (compare(x, y) | 0),
    }))));
}

export const modelToSymbols = (() => {
    let l_4;
    const l_2 = Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_wire_)(sheet_);
    l_4 = Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_BusWireT_symbol_)(l_2);
    return Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_symbols_)(l_4);
})();

/**
 * Evaluates a list of constraints got from slots against a set of parameter bindings to
 * check what values of param are allowed.
 * 
 * Pure: the constraints that are not met are returned, not dispatched. This used to send a
 * notification from inside a List.filter, and one of its two callers is editParameterBox's
 * isDisabled - which the popup asks, while rendering, whether its button should be greyed out. A
 * constraint that could not be evaluated would have dispatched from there, re-rendered, and
 * dispatched again. It also sent SetPopupDialogText, which is where some popups keep the text the
 * user is typing.
 * 
 * Everything the caller has to say is carried in the ParamConstraint it gets back, which is where
 * the caller already looks for it: a bound that cannot be worked out comes back as a constraint
 * whose message says so.
 */
export function evaluateConstraints(paramBindings, exprSpecs) {
    const matchValue_2 = collect((exprSpec) => {
        const matchValue = evaluateParamExpression(paramBindings, exprSpec.Expression);
        if (matchValue.tag === 0) {
            const value = matchValue.fields[0];
            return choose((konst) => {
                const patternInput = (konst.tag === 0) ? [konst.fields[0], konst.fields[1]] : [konst.fields[0], konst.fields[1]];
                const bound_1 = patternInput[0];
                const matchValue_1 = evaluateParamExpression(paramBindings, bound_1);
                if (matchValue_1.tag === 0) {
                    const limit = matchValue_1.fields[0];
                    let matchResult;
                    if (konst.tag === 0) {
                        if (compare_1(value, limit) < 0) {
                            matchResult = 1;
                        }
                        else {
                            matchResult = 2;
                        }
                    }
                    else if (compare_1(value, limit) > 0) {
                        matchResult = 0;
                    }
                    else {
                        matchResult = 2;
                    }
                    switch (matchResult) {
                        case 0:
                            return konst;
                        case 1:
                            return konst;
                        default:
                            return undefined;
                    }
                }
                else {
                    return new ParamConstraint(/* MinVal */ 0, [bound_1, concat(patternInput[1], " - but that limit could not be worked out. ", matchValue_1.fields[0])]);
                }
            }, exprSpec.Constraints);
        }
        else {
            return singleton(new ParamConstraint(/* MinVal */ 0, [exprSpec.Expression, concat("This value could not be worked out. ", matchValue.fields[0])]));
        }
    }, exprSpecs);
    if (isEmpty(matchValue_2)) {
        return new FSharpResult$2(/* Ok */ 0, [undefined]);
    }
    else {
        return new FSharpResult$2(/* Error */ 1, [matchValue_2]);
    }
}

/**
 * Get LoadedComponent for currently open sheet
 * This cannot fail, because LoadedComponent must be loaded for sheet to be open
 */
export function getCurrentSheet(model) {
    let sheetName;
    const matchValue = model.CurrentProj;
    sheetName = ((matchValue == null) ? toFail(printf("Cannot find sheet because no project is open")) : matchValue.OpenFileName);
    const _arg = tryFind((lc) => (lc.Name === sheetName), tryGetLoadedComponents(model));
    if (_arg == null) {
        return toFail(printf("No loaded component with same name as open sheet"));
    }
    else {
        return _arg;
    }
}

/**
 * The parameter data of a sheet, empty where it declares none. Every reader goes through
 * CommonTypes.lcParameterDefs_, which is also what writing to a sheet goes through.
 */
export function getParamDefs(loadedComponent) {
    return Optic_Get_op_HatDot_Z146BA564(Optic_Get.Get, lcParameterDefs_)(loadedComponent);
}

/**
 * Get the parameter declarations (defaults and descriptions) for a LoadedComponent
 */
export function getDefaultParamDefs(loadedComponent) {
    return getParamDefs(loadedComponent).DefaultBindings;
}

/**
 * Get default parameter bindings for LoadedComponent, for use as an evaluation environment
 */
export function getDefaultParams(loadedComponent) {
    return bindingsOf(getDefaultParamDefs(loadedComponent));
}

/**
 * Get the parameterised slots of a LoadedComponent
 */
export function getParamSlots(loadedComponent) {
    return getParamDefs(loadedComponent).ParamSlots;
}

/**
 * Get current loaded component parameter info
 * Returns empty maps for ParamSlots and DefaultBindings if None
 */
export function getLCParamInfo(model) {
    let ParamSlots;
    return defaultArg(Optic_Get_op_HatDot_Z32FCD1E1(Optic_Get.Get, lcParameterInfoOfModel_)(model), (ParamSlots = empty({
        Compare: (x, y) => (compare(x, y) | 0),
    }), new ParameterDefs(empty({
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    }), ParamSlots)));
}

/**
 * Update a custom component's input/output label widths based on parameter evaluations.
 * The width rewrite itself is CanvasExtractor.withPortWidths, which propagation also uses, so an
 * instance resized by an edit and one resized by a recomputation come out the same shape.
 */
export function updateCustomComponent(labelToEval, newBindings, comp) {
    let bind$0040;
    const matchValue = comp.Type;
    if (matchValue.tag === 26) {
        return new Component_1(comp.Id, new ComponentType(/* Custom */ 26, [(bind$0040 = withPortWidths(labelToEval, matchValue.fields[0]), new CustomComponentType(bind$0040.Name, bind$0040.InputLabels, bind$0040.OutputLabels, bind$0040.Form, newBindings, bind$0040.Description))]), comp.Label, comp.InputPorts, comp.OutputPorts, comp.X, comp.Y, comp.H, comp.W, comp.SymbolInfo, comp.SlotInfo);
    }
    else {
        return comp;
    }
}

/**
 * The port widths an instance of `childSheet` has when it binds its parameters as given.
 * 
 * The work is CanvasExtractor.signatureOfInstance's, which is the one place that knows what an
 * instance's ports are; this only turns its answer into the label-to-width map that
 * updateCustomComponent wants. The label comes from the child sheet's Input or Output COMPONENT,
 * not from the `IO` slot that sets its width, so a port renamed since its slot was created is
 * still sized by that slot - see ParameterTypes.sameSlotName.
 */
export function portWidthsOfInstance(ldcs, parentBindings, childSheet, instanceBindings) {
    let option_1, tupledArg;
    return defaultArg((option_1 = signatureOfInstance(ldcs, parentBindings, childSheet, instanceBindings), (option_1 != null) ? ((tupledArg = option_1, ofList(append(tupledArg[0], tupledArg[1]), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }))) : undefined), empty({
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }));
}

/**
 * What is wrong, in the words of whoever the message was written for, with setting one parameter
 * of an instance of `childSheet` to `value`.
 * 
 * An instance binding used to be checked against nothing at all: the boxes that set one pass an
 * empty constraint list, so the bounds a width must satisfy - at least one bit, at most
 * maxIssieBusWidth - applied only to a value typed straight into a component's own box. Binding a
 * child parameter to a hundred thousand sized the child's ports at a hundred thousand bits, and
 * the first thing to object was the simulator allocating them.
 * 
 * The bounds cannot be handed to paramInputField as a ParamConstraint list, which is why this is
 * a function instead. They belong to the slots of the CHILD sheet, and are expressions in the
 * CHILD's parameters; paramInputField evaluates its constraints in the parameters of the sheet
 * the instance sits on, where those mean nothing. So the check resolves the child sheet at the
 * bindings it would have - the same thing editParameterBox does for the open sheet, and the same
 * constraints, derived by ComponentSlots.constraintsFor from each slot's own component.
 * 
 * Only the slots that USE the parameter are checked. Every other slot is being evaluated at
 * values this box is not setting, so a complaint from one would name the wrong box.
 */
export function instanceBindingProblem(ldcs, childSheet, baseBindings, name, value) {
    const matchValue = tryFind((ldc) => (ldc.Name === childSheet), ldcs);
    if (matchValue != null) {
        const childLdc = matchValue;
        const slots = sheetParamSlots(childLdc);
        const bindings = add(name, new ParamExpression(/* PInt */ 0, [value]), baseBindings);
        const typeOfComp = ofList(map((comp) => [comp.Id, comp.Type], childLdc.CanvasState[0]), {
            Compare: (x, y) => (compare(x, y) | 0),
        });
        const _arg = evaluateConstraints(bindings, choose((tupledArg) => {
            const slot = tupledArg[0];
            const option_1 = tryFind_1(slot.CompId, typeOfComp);
            if (option_1 != null) {
                return new ConstrainedExpr(tupledArg[1].Expression, constraintsFor(slot.CompSlot, option_1));
            }
            else {
                return undefined;
            }
        }, slotsUsingParam(name, slots)));
        let matchResult, err;
        if (_arg.tag === 1) {
            if (!isEmpty(_arg.fields[0])) {
                if (head(_arg.fields[0]).tag === 1) {
                    matchResult = 2;
                    err = head(_arg.fields[0]).fields[1];
                }
                else {
                    matchResult = 2;
                    err = head(_arg.fields[0]).fields[1];
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 0;
        }
        switch (matchResult) {
            case 0:
                return new FSharpResult$2(/* Ok */ 0, [undefined]);
            case 1:
                return new FSharpResult$2(/* Ok */ 0, [undefined]);
            default:
                return new FSharpResult$2(/* Error */ 1, [err]);
        }
    }
    else {
        return new FSharpResult$2(/* Ok */ 0, [undefined]);
    }
}

/**
 * Every join on the open sheet carrying the given channel name, whichever direction it faces.
 * 
 * A channel is one signal, so its joins are one width: a JoinOut of 8 bits read by a JoinIn of 4
 * is not a design that means anything. Rather than checking for that state and reporting it, the
 * width is set on all of them together and the state never exists.
 * 
 * `channel` is taken as TYPED and put through the same normalisation a label gets on its way onto
 * a component, so that every caller matches the same way. One asks with a stored label and the
 * other with what someone is typing into a dialog box: labels are uppercased as they are made, so
 * comparing raw text found nothing for 'carry' while 'CARRY' was on the sheet - and the dialog
 * then offered a width for a channel that already had one.
 */
export function joinsOnChannel(model, channel) {
    const wanted = extractLabelBase(channel);
    return ofSeq(filter((comp) => {
        if (comp.Label === wanted) {
            const matchValue = comp.Type;
            switch (matchValue.tag) {
                case 52:
                case 53:
                    return true;
                default:
                    return false;
            }
        }
        else {
            return false;
        }
    }, map_1((sym) => sym.Component, values(model.Sheet.Wire.Symbol.Symbols))));
}

/**
 * Push the values of the parameterised slots of ONE component onto the canvas.
 * All of a component's slots are applied together because two of the messages replace a whole
 * field of the component type - a SplitN's width and LSB lists, a custom component's parameter
 * bindings - and are built here from `model`, which is a snapshot: issued one slot at a time
 * they would overwrite each other, leaving all but the last slot at its old value.
 * (ChangeWidth and ChangeInputValue read the live symbol and so do not have this problem.)
 */
export function updateComponentSlots(dispatch, model, compId, slotValues) {
    const sheetDispatch = (sMsg) => {
        dispatch(new Msg(/* Sheet */ 3, [sMsg]));
    };
    const comp = DrawModelType_SheetT_Model__Model_GetComponentById_72DDFA37(model.Sheet, compId);
    const compId_1 = comp.Id;
    const asInt = (slot_1, value) => {
        const matchValue = tryIntOfParamInt(value);
        if (matchValue == null) {
            warn(`Parameter value ${value} is too large for slot ${slot_1}, which holds a whole number: the component is unchanged`);
            return undefined;
        }
        else {
            return matchValue;
        }
    };
    const intValueOf = (slot_2) => {
        const option = tryPick((tupledArg) => {
            if (equals(tupledArg[0], slot_2)) {
                return tupledArg[1];
            }
            else {
                return undefined;
            }
        }, slotValues);
        const binder = curry2(asInt)(slot_2);
        const option_1 = option;
        if (option_1 != null) {
            return binder(option_1);
        }
        else {
            return undefined;
        }
    };
    const matchValue_1 = comp.Type;
    switch (matchValue_1.tag) {
        case 30: {
            DrawModelType_SheetT_Model__Model_ChangeSplitN(model.Sheet, sheetDispatch, compId_1, matchValue_1.fields[0], mapIndexed((i, w) => (defaultArg(intValueOf(new CompSlotName(/* SplitNWidth */ 3, [i])), w) | 0), matchValue_1.fields[1]), mapIndexed((i_1, l) => (defaultArg(intValueOf(new CompSlotName(/* SplitNLSB */ 4, [i_1])), l) | 0), matchValue_1.fields[2]));
            break;
        }
        case 26: {
            const customComp = matchValue_1.fields[0];
            const newBindings = fold((bindings, tupledArg_1) => {
                const slot_3 = tupledArg_1[0];
                if (slot_3.tag === 2) {
                    return add(new ParamName(slot_3.fields[0]), new ParamExpression(/* PInt */ 0, [tupledArg_1[1]]), bindings);
                }
                else {
                    return bindings;
                }
            }, defaultArg(customComp.ParameterBindings, empty({
                Compare: (x, y) => (compare(x, y) | 0),
            })), slotValues);
            const matchValue_2 = model.CurrentProj;
            if (matchValue_2 == null) {
                dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* ChangeCustom */ 26, [compId_1, comp, new ComponentType(/* Custom */ 26, [new CustomComponentType(customComp.Name, customComp.InputLabels, customComp.OutputLabels, customComp.Form, newBindings, customComp.Description)])])])])]));
                DrawModelType_SheetT_Model__Model_DoBusWidthInference_Z1E9EDA9D(model.Sheet, sheetDispatch);
            }
            else {
                dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* ChangeCustom */ 26, [compId_1, comp, updateCustomComponent(portWidthsOfInstance(matchValue_2.LoadedComponents, paramBindingsOfModel(model), customComp.Name, newBindings), newBindings, comp).Type])])])]));
                DrawModelType_SheetT_Model__Model_DoBusWidthInference_Z1E9EDA9D(model.Sheet, sheetDispatch);
            }
            break;
        }
        default:
            iterate((tupledArg_2) => {
                const slot_4 = tupledArg_2[0];
                const value_3 = tupledArg_2[1];
                const matchValue_3 = comp.Type;
                let matchResult;
                switch (matchValue_3.tag) {
                    case 6: {
                        switch (slot_4.tag) {
                            case 0: {
                                matchResult = 3;
                                break;
                            }
                            case 6:
                            case 7: {
                                matchResult = 4;
                                break;
                            }
                            case 5: {
                                matchResult = 6;
                                break;
                            }
                            case 3:
                            case 4: {
                                matchResult = 7;
                                break;
                            }
                            case 8: {
                                matchResult = 9;
                                break;
                            }
                            case 2: {
                                matchResult = 10;
                                break;
                            }
                            default:
                                matchResult = 0;
                        }
                        break;
                    }
                    case 47: {
                        switch (slot_4.tag) {
                            case 0: {
                                matchResult = 3;
                                break;
                            }
                            case 6:
                            case 7: {
                                matchResult = 4;
                                break;
                            }
                            case 5: {
                                matchResult = 6;
                                break;
                            }
                            case 3:
                            case 4: {
                                matchResult = 7;
                                break;
                            }
                            case 8: {
                                matchResult = 9;
                                break;
                            }
                            case 2: {
                                matchResult = 10;
                                break;
                            }
                            default:
                                matchResult = 0;
                        }
                        break;
                    }
                    case 7: {
                        switch (slot_4.tag) {
                            case 0: {
                                matchResult = 3;
                                break;
                            }
                            case 6:
                            case 7: {
                                matchResult = 4;
                                break;
                            }
                            case 5: {
                                matchResult = 6;
                                break;
                            }
                            case 3:
                            case 4: {
                                matchResult = 7;
                                break;
                            }
                            case 8: {
                                matchResult = 9;
                                break;
                            }
                            case 2: {
                                matchResult = 10;
                                break;
                            }
                            default:
                                matchResult = 1;
                        }
                        break;
                    }
                    case 5: {
                        switch (slot_4.tag) {
                            case 0: {
                                matchResult = 3;
                                break;
                            }
                            case 6:
                            case 7: {
                                matchResult = 4;
                                break;
                            }
                            case 5: {
                                matchResult = 6;
                                break;
                            }
                            case 3:
                            case 4: {
                                matchResult = 7;
                                break;
                            }
                            case 8: {
                                matchResult = 9;
                                break;
                            }
                            case 2: {
                                matchResult = 10;
                                break;
                            }
                            default:
                                matchResult = 2;
                        }
                        break;
                    }
                    case 0: {
                        switch (slot_4.tag) {
                            case 6:
                            case 7: {
                                matchResult = 4;
                                break;
                            }
                            case 5: {
                                matchResult = 5;
                                break;
                            }
                            case 3:
                            case 4: {
                                matchResult = 7;
                                break;
                            }
                            case 8: {
                                matchResult = 9;
                                break;
                            }
                            case 2: {
                                matchResult = 10;
                                break;
                            }
                            default:
                                matchResult = 3;
                        }
                        break;
                    }
                    case 52: {
                        switch (slot_4.tag) {
                            case 6:
                            case 7: {
                                matchResult = 4;
                                break;
                            }
                            case 5: {
                                matchResult = 6;
                                break;
                            }
                            case 3:
                            case 4: {
                                matchResult = 7;
                                break;
                            }
                            case 8: {
                                matchResult = 8;
                                break;
                            }
                            case 2: {
                                matchResult = 10;
                                break;
                            }
                            default:
                                matchResult = 3;
                        }
                        break;
                    }
                    case 53: {
                        switch (slot_4.tag) {
                            case 6:
                            case 7: {
                                matchResult = 4;
                                break;
                            }
                            case 5: {
                                matchResult = 6;
                                break;
                            }
                            case 3:
                            case 4: {
                                matchResult = 7;
                                break;
                            }
                            case 8: {
                                matchResult = 8;
                                break;
                            }
                            case 2: {
                                matchResult = 10;
                                break;
                            }
                            default:
                                matchResult = 3;
                        }
                        break;
                    }
                    default:
                        switch (slot_4.tag) {
                            case 6:
                            case 7: {
                                matchResult = 4;
                                break;
                            }
                            case 5: {
                                matchResult = 6;
                                break;
                            }
                            case 3:
                            case 4: {
                                matchResult = 7;
                                break;
                            }
                            case 8: {
                                matchResult = 9;
                                break;
                            }
                            case 2: {
                                matchResult = 10;
                                break;
                            }
                            default:
                                matchResult = 3;
                        }
                }
                switch (matchResult) {
                    case 0: {
                        DrawModelType_SheetT_Model__Model_ChangeLSB(model.Sheet, sheetDispatch, compId_1, value_3);
                        break;
                    }
                    case 1: {
                        dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* ChangeConstant */ 22, [compId_1, value_3, toString(value_3)])])])]));
                        break;
                    }
                    case 2: {
                        dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* ChangeBusCompare */ 23, [compId_1, value_3, toString(value_3)])])])]));
                        break;
                    }
                    case 3: {
                        const option_6 = asInt(slot_4, value_3);
                        if (option_6 != null) {
                            ((width) => {
                                DrawModelType_SheetT_Model__Model_ChangeWidth(model.Sheet, sheetDispatch, compId_1, width);
                            })(option_6);
                        }
                        break;
                    }
                    case 4: {
                        const matchValue_5 = trySetSlotValue(slot_4, value_3, comp.Type);
                        let matchResult_1, mem;
                        if (matchValue_5 != null) {
                            switch (matchValue_5.tag) {
                                case 40: {
                                    matchResult_1 = 0;
                                    mem = matchValue_5.fields[0];
                                    break;
                                }
                                case 41: {
                                    matchResult_1 = 0;
                                    mem = matchValue_5.fields[0];
                                    break;
                                }
                                case 39: {
                                    matchResult_1 = 0;
                                    mem = matchValue_5.fields[0];
                                    break;
                                }
                                case 42: {
                                    matchResult_1 = 0;
                                    mem = matchValue_5.fields[0];
                                    break;
                                }
                                default:
                                    matchResult_1 = 1;
                            }
                        }
                        else {
                            matchResult_1 = 1;
                        }
                        switch (matchResult_1) {
                            case 0: {
                                DrawModelType_SheetT_Model__Model_UpdateMemory(model.Sheet, sheetDispatch, compId_1, (_arg) => mem);
                                DrawModelType_SheetT_Model__Model_DoBusWidthInference_Z1E9EDA9D(model.Sheet, sheetDispatch);
                                break;
                            }
                            case 1: {
                                warn(`Memory width slot ${slot_4} does not apply to ${comp.Type}`);
                                break;
                            }
                        }
                        break;
                    }
                    case 5: {
                        DrawModelType_SheetT_Model__Model_ChangeInputValue(model.Sheet, sheetDispatch, compId_1, value_3);
                        break;
                    }
                    case 6: {
                        toFail(`Default value cannot be set on ${comp.Type}`);
                        break;
                    }
                    case 7: {
                        toFail(`SplitN slots cannot be applied to ${comp.Type}`);
                        break;
                    }
                    case 8: {
                        const option_8 = asInt(slot_4, value_3);
                        if (option_8 != null) {
                            ((newNum) => {
                                DrawModelType_SheetT_Model__Model_ChangeJoinNum(model.Sheet, sheetDispatch, compId_1, newNum);
                            })(option_8);
                        }
                        break;
                    }
                    case 9: {
                        toFail(`A channel number cannot be set on ${comp.Type}`);
                        break;
                    }
                    case 10: {
                        toFail(printf("CustomCompParam can only be used with Custom components"));
                        break;
                    }
                }
            }, slotValues);
    }
    iterate((tupledArg_3) => {
        const slot_5 = tupledArg_3[0];
        const matchValue_6 = comp.Type;
        let matchResult_2;
        switch (slot_5.tag) {
            case 0: {
                switch (matchValue_6.tag) {
                    case 28:
                    case 6:
                    case 7: {
                        matchResult_2 = 0;
                        break;
                    }
                    default:
                        matchResult_2 = 1;
                }
                break;
            }
            case 1: {
                matchResult_2 = 1;
                break;
            }
            default:
                matchResult_2 = 2;
        }
        switch (matchResult_2) {
            case 0: {
                break;
            }
            case 1: {
                const option_10 = asInt(slot_5, tupledArg_3[1]);
                if (option_10 != null) {
                    dispatch(new Msg(/* ReloadSelectedComponent */ 87, [option_10]));
                }
                break;
            }
            case 2: {
                break;
            }
        }
    }, slotValues);
}

/**
 * Use sheet component update functions to perform an update to a single slot.
 */
export function updateComponent(dispatch, model, slot, value) {
    updateComponentSlots(dispatch, model, slot.CompId, singleton([slot.CompSlot, value]));
}

/**
 * The open sheet's parameter data has just changed.
 * 
 * Nothing in the canvas need have changed with it: declaring a parameter, writing its
 * description, or giving a slot an expression that works out to the width already shown all leave
 * the canvas identical. UpdateHelpers.currentSheetIsOutOfDate compares only the canvas, so
 * without this the save button stays dark, switching sheets does not save, and the work is
 * silently dropped.
 * 
 * LoadedComponentIsOutOfDate is the flag that survives: SavedSheetIsOutOfDate is recomputed from
 * it on every draw block message, and is set here too only so that the button responds before the
 * next such message arrives. Saving the sheet clears both.
 * The work is ParameterAnalysis.markSheetOutOfDate, which is a function of the loaded components
 * alone and so can be tested without building a Model; this only reaches it.
 */
export function markSheetParamsChanged(model) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const proj = matchValue;
        return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, savedSheetIsOutOfDate_)(true)(Optic_Map_op_HatPercent_Z32F545AB(Optic_Map.Map$, Compose_Prism_op_GreaterQmarkGreater_507FA136(Compose_Prism.Prism, loadedComponents_)(projectOpt_))((ldcs) => markSheetOutOfDate(proj.OpenFileName, ldcs))(model));
    }
    else {
        return model;
    }
}

/**
 * Adds or updates a parameter slot in loaded component param slots
 * Removes the entry if the expression does not contain parameters
 */
export function updateParamSlot(slot, exprSpec, model) {
    const paramSlots = defaultArg(Optic_Get_op_HatDot_Z32FCD1E1(Optic_Get.Get, paramSlotsOfModel_)(model), empty({
        Compare: (x, y) => (compare(x, y) | 0),
    }));
    const newParamSlots = exprContainsParams(exprSpec.Expression) ? addSlot(slot, exprSpec, paramSlots) : removeSlot(slot, paramSlots);
    if (newParamSlots.Equals(paramSlots)) {
        return model;
    }
    else {
        return syncArrayTextOfOpenSheet(markSheetParamsChanged(Optic_Set_op_HatEquals_Z32E30375(Optic_Set.Set$, paramSlotsOfModel_)(newParamSlots)(model)));
    }
}

/**
 * The components whose matching slot must be set whenever this one is.
 * 
 * A join's WIDTH belongs to the CHANNEL and not to the component: the value passed from one copy
 * to another is one signal, so a JoinOut and every JoinIn reading it are the same number of bits
 * by definition. Setting one therefore sets all of them, which is what keeps a state where they
 * disagree from existing at all. Every other slot governs its own component and nothing else.
 * 
 * They share a LABEL - that is what being on one channel means - so they share the slot name too,
 * and the caller can use the one it was given for all of them.
 */
export function componentsSetTogether(model, comp, compSlot) {
    const matchValue = comp.Type;
    let matchResult;
    switch (matchValue.tag) {
        case 52: {
            if (compSlot.tag === 1) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
            break;
        }
        case 53: {
            if (compSlot.tag === 1) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
            break;
        }
        default:
            matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return List_distinctBy((c) => c.Id, cons(comp, joinsOnChannel(model, comp.Label)), {
                Equals: equals,
                GetHashCode: (x) => (safeHash(x) | 0),
            });
        default:
            return singleton(comp);
    }
}

/**
 * Apply one properties box's expression and its value to every slot that box governs, and say so
 * where that reached further than the component being edited.
 * 
 * **The expression as well as the value, and that is the point.** Setting only the value gave the
 * other joins on a channel the number once and no slot to follow: parameterise a join's width as
 * `N`, change `N`, and the end that was edited resized while the others sat at the number they had
 * been handed - the disagreement the channel rule exists to prevent, arrived at through the
 * mechanism meant to prevent it. One function so that the two cannot be spread by halves again.
 */
export function applySlotEdit(dispatch, model, comp, compSlot, exprSpec, value) {
    const comps = componentsSetTogether(model, comp, compSlot);
    const slots = map((c) => (new ParamSlot(c.Id, compSlot)), comps);
    iterate((slot) => {
        updateComponent(dispatch, model, slot, value);
    }, slots);
    dispatch(new Msg(/* UpdateModel */ 41, [(m) => fold((m_1, slot_1) => updateParamSlot(slot_1, exprSpec, m_1), m, slots)]));
    const matchValue = filter_1((c_1) => !equals(c_1.Id, comp.Id), comps);
    if (isEmpty(matchValue)) {
    }
    else {
        const others = matchValue;
        const names = StringModule_Concat(", ", List_distinct(map((c_2) => c_2.Label, others), {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        }));
        dispatch(new Msg(/* SetPropertiesNotification */ 83, [successPropertiesNotification(`Channel ${comp.Label} carries one signal, so its other ${length(others)} join(s) (${names}) are now ${value} bits too.`)]));
    }
}

/**
 * Add the parameter information from a newly created component to paramSlots
 */
export function addParamComponent(newCompSpec, dispatch, compId) {
    const slot = new ParamSlot(compId, newCompSpec.CompSlot);
    const exprSpec = new ConstrainedExpr(newCompSpec.Expression, newCompSpec.Constraints);
    dispatch(new Msg(/* UpdateModel */ 41, [(model) => updateParamSlot(slot, exprSpec, model)]));
}

/**
 * Add the parameter information from several slots of one newly created component.
 * Used when a custom component instance is placed: it binds every parameter its sheet declares
 * at once, so one hook has to create all of their slots.
 */
export function addParamComponents(newCompSpecs, dispatch, compId) {
    iterate((spec) => {
        addParamComponent(spec, dispatch, compId);
    }, newCompSpecs);
}

/**
 * The grammar of the box above it, offered as a link that opens into the box's own field.
 * 
 * Belongs to a box rather than to the pane. It appeared once at the foot of the pane, where it
 * explained boxes several inches above it and was read as a footnote to the whole component; and
 * it showed on the sheet-properties pane, which has no box to type an expression into at all.
 * 
 * Two conditions, and both matter. The open sheet must declare a property - with none, an
 * expression can only be arithmetic on numbers the user has already typed, so the grammar is
 * advertising a feature with no use. And the field must have focus, which CSS decides with
 * :focus-within: the link is one line, but a line under every width box in the pane is a line
 * nobody asked for until they are actually typing in one.
 * 
 * A `details` with its marker taken off, so the link is a link and the disclosure state costs
 * nothing to keep: it opens and closes by itself and remembers nothing between selections, which
 * is right for a reference someone reads once.
 */
export function expressionSyntaxHelp(model) {
    let children_2;
    if (model.CurrentProj != null) {
        if (isEmpty_1(getDefaultParamDefs(getCurrentSheet(model)))) {
            return defaultOf();
        }
        else {
            const children_4 = [react.createElement("summary", {}, Expressions_title), (children_2 = [render((value) => {
            }, Expressions_syntax)], react.createElement("div", {
                className: "expressionSyntaxBody",
            }, ...children_2))];
            return react.createElement("details", {
                className: "expressionSyntax",
            }, ...children_4);
        }
    }
    else {
        return defaultOf();
    }
}

/**
 * Create a generic input field which accepts and parses parameter expressions
 * Validity of inputs is checked by parser
 * Specific constraints can be passed by callee
 */
export function paramInputField(model, prompt, defaultValue, currentValue, currentExpr, constraints, extraCheck, comp, compSlotName, dispatch) {
    let option_1, option_12, option_9, option_7, option_16, option_19, matchValue_3;
    const boxKey = paramBoxKey((option_1 = comp, (option_1 != null) ? option_1.Id : undefined), compSlotName);
    const boxState = tryFind_1(boxKey, defaultArg(model.PopupDialogData.DialogState, empty({
        Compare: (x, y) => (compare(x, y) | 0),
    })));
    const slots = getParamSlots(getCurrentSheet(model));
    const committedString = defaultArg((option_12 = orElse((option_9 = ((option_7 = comp, (option_7 != null) ? tryFindSlot(new ParamSlot(option_7.Id, compSlotName), slots) : undefined)), (option_9 != null) ? option_9.Expression : undefined), currentExpr), (option_12 != null) ? renderParamExpression(option_12, 0) : undefined), toString(defaultArg(currentValue, defaultValue)));
    const inputString = defaultArg((option_16 = boxState, (option_16 != null) ? option_16.Text : undefined), committedString);
    const errText = defaultArg((option_19 = boxState, (option_19 != null) ? ((matchValue_3 = option_19.Spec, (matchValue_3.tag === 1) ? matchValue_3.fields[0] : "")) : undefined), "");
    return div(singleton(new Option(/* Props */ 11, [singleton(new HTMLAttr(/* Class */ 65, ["paramField"]))])), toList(delay(() => append_1((prompt !== "") ? singleton_1(fieldLabel(prompt)) : empty_1(), delay(() => append_1(singleton_1(div(singleton(Option.HasAddons), toList(delay(() => append_1(singleton_1(div_1(empty_2(), singleton(input(cons(new Option_1(/* Type */ 1, [IInputType.Text$]), toList(delay(() => append_1((errText !== "") ? singleton_1(new Option_1(/* CustomClass */ 16, ["is-danger"])) : empty_1(), delay(() => append_1(singleton_1(new Option_1(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e) => {
        preventDefault(e);
    }]), new HTMLAttr(/* SpellCheck */ 148, [false]), new HTMLAttr(/* Name */ 123, [(prompt === "") ? toString_1(compSlotName) : prompt]), ["style", {
        width: "200px",
    }]])])), delay(() => append_1(singleton_1(new Option_1(/* Value */ 8, [inputString])), delay(() => append_1(singleton_1(new Option_1(/* Type */ 1, [IInputType.Text$])), delay(() => singleton_1(new Option_1(/* OnChange */ 13, [(arg) => {
        let option_3;
        const inputExpr = getTextEventValue(arg);
        const paramBindings = paramBindingsOfModel(model);
        const exprResult = parseExpression(inputExpr);
        const newVal = Result_Bind((paramExpr) => evaluateParamExpression(paramBindings, paramExpr), exprResult);
        const constraintCheck = Result_Bind((expr) => {
            const matchValue = evaluateConstraints(paramBindings, singleton(new ConstrainedExpr(expr, constraints)));
            if (matchValue.tag === 1) {
                if (!isEmpty(matchValue.fields[0])) {
                    const firstConstraint = head(matchValue.fields[0]);
                    let err;
                    if (firstConstraint.tag === 1) {
                        err = firstConstraint.fields[1];
                    }
                    else {
                        err = firstConstraint.fields[1];
                    }
                    return new FSharpResult$2(/* Error */ 1, [err]);
                }
                else {
                    return toFail(printf("Cannot have error list with no elements"));
                }
            }
            else {
                return new FSharpResult$2(/* Ok */ 0, [undefined]);
            }
        }, exprResult);
        let matchResult_1, expr_2, value_3, err_2;
        const copyOfStruct = newVal;
        if (copyOfStruct.tag === 1) {
            matchResult_1 = 1;
            err_2 = copyOfStruct.fields[0];
        }
        else {
            const copyOfStruct_1 = constraintCheck;
            if (copyOfStruct_1.tag === 1) {
                matchResult_1 = 1;
                err_2 = copyOfStruct_1.fields[0];
            }
            else {
                const copyOfStruct_2 = exprResult;
                if (copyOfStruct_2.tag === 0) {
                    matchResult_1 = 0;
                    expr_2 = copyOfStruct_2.fields[0];
                    value_3 = copyOfStruct.fields[0];
                }
                else {
                    matchResult_1 = 2;
                }
            }
        }
        switch (matchResult_1) {
            case 0: {
                const matchValue_2 = defaultArg((option_3 = extraCheck, (option_3 != null) ? option_3(value_3) : undefined), new FSharpResult$2(/* Ok */ 0, [undefined]));
                if (matchValue_2.tag === 1) {
                    dispatch(new Msg(/* AddPopupDialogParamSpec */ 63, [[boxKey, new ParamBoxState(inputExpr, new FSharpResult$2(/* Error */ 1, [matchValue_2.fields[0]]))]]));
                }
                else {
                    const expr_1 = expr_2;
                    const value = value_3;
                    dispatch(new Msg(/* AddPopupDialogParamSpec */ 63, [[boxKey, new ParamBoxState(inputExpr, new FSharpResult$2(/* Ok */ 0, [new NewParamCompSpec(compSlotName, expr_1, constraints, value)]))]]));
                    if (comp == null) {
                    }
                    else {
                        applySlotEdit(dispatch, model, comp, compSlotName, new ConstrainedExpr(expr_1, constraints), value);
                    }
                }
                break;
            }
            case 1: {
                dispatch(new Msg(/* AddPopupDialogParamSpec */ 63, [[boxKey, new ParamBoxState(inputExpr, new FSharpResult$2(/* Error */ 1, [err_2]))]]));
                break;
            }
            case 2: {
                toFail(printf("Value cannot exist with invalid expression"));
                break;
            }
        }
    }]))))))))))))))))), delay(() => (((currentValue != null) && (toString(value_10(currentValue)) !== inputString)) ? singleton_1(p_4(empty_2(), singleton(a_1(singleton(new Option_2(/* IsStatic */ 14, [true])), singleton(`= ${value_10(currentValue)}`))))) : empty_1()))))))), delay(() => append_1(singleton_1(react.createElement("div", {
        className: "propertyMessage",
    }, errText)), delay(() => singleton_1(expressionSyntaxHelp(model)))))))))));
}

/**
 * Update the values of all parameterised components with a new set of bindings
 * This can only be called after the validity and constraints of all
 * expressions are checked
 */
export function updateComponents(newBindings, model, dispatch) {
    iterate((tupledArg_1) => {
        updateComponentSlots(dispatch, model, tupledArg_1[0], map((tuple_1) => tuple_1[1], tupledArg_1[1]));
    }, List_groupBy((tuple) => tuple[0], choose((tupledArg) => {
        const slot_1 = tupledArg[0];
        let option_2;
        const slot = slot_1;
        const matchValue = containsKey(slot.CompId, model.Sheet.Wire.Symbol.Symbols);
        if (matchValue) {
            const matchValue_1 = evaluateParamExpression(newBindings, tupledArg[1].Expression);
            if (matchValue_1.tag === 1) {
                warn(`Skipping parameter slot of component ${slot.CompId}: ${matchValue_1.fields[0]}`);
                option_2 = undefined;
            }
            else {
                option_2 = matchValue_1.fields[0];
            }
        }
        else {
            warn(`Skipping parameter slot of component ${slot.CompId}, which is not on this sheet`);
            option_2 = undefined;
        }
        if (option_2 != null) {
            return [slot_1.CompId, [slot_1.CompSlot, option_2]];
        }
        else {
            return undefined;
        }
    }, toList_1(defaultArg(Optic_Get_op_HatDot_Z32FCD1E1(Optic_Get.Get, paramSlotsOfModel_)(model), empty({
        Compare: (x, y) => (compare(x, y) | 0),
    })))), {
        Equals: equals,
        GetHashCode: (x_1) => (safeHash(x_1) | 0),
    }));
}

/**
 * Bring every sheet into line with what its design sets its parameters to.
 * 
 * The recomputation itself is pure (ParameterAnalysis.propagateParameterValues); this is the part
 * that has to touch the world, and it treats the open sheet differently from the rest because its
 * canvas is not in LoadedComponents but in the draw block:
 * 
 * - a CLOSED sheet whose values changed is rewritten and written to its file at once, because
 * only the open sheet is ever allowed to be unsaved. A sheet that cannot be written - a
 * library component, which belongs to its library - is still brought into line in memory, so
 * that looking at it shows the right thing, but its file is left alone and it is not called
 * unsaved: the difference is derived and there is nothing for the user to save;
 * - the OPEN sheet's values are pushed through the same symbol-change path the properties pane
 * uses, so symbol size, ports and geometry are recomputed rather than patched, and the change
 * joins that sheet's undo history like any other edit.
 */
export function propagateParameters(model, dispatch) {
    let option_3, option_1;
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        const openName = project.OpenFileName;
        const before = getUpdatedLoadedComponents(project, model).LoadedComponents;
        const updated = saveDirtyClosedSheets(openName, map((tupledArg) => {
            const b = tupledArg[0];
            const a = tupledArg[1];
            if (!equalArrays(a.CanvasState, b.CanvasState) ? true : !equals(a.LCParameterSlots, b.LCParameterSlots)) {
                return new LoadedComponent(a.Name, a.TimeStamp, a.FilePath, a.WaveInfo, a.CanvasState, a.InputLabels, a.OutputLabels, a.LCParameterSlots, a.Form, true, a.Description, a.IsTopSheet, a.ArrayInfo);
            }
            else {
                return a;
            }
        }, zip(before, syncInstancePorts(propagateParameterValues(before)))));
        dispatch(new Msg(/* UpdateModel */ 41, [(m) => (new Model(m.WindowWidth, m.KeyFocusPane, m.RunAfterRenderWithSpinner, m.UserData, m.WaveSim, m.WaveSimSheet, m.UISheetTrail, m.Spinner, m.Sheet, m.IsLoading, m.LastChangeCheckTime, m.LastSimulatedCanvasState, m.LastDetailedSavedState, m.CurrentSelected, m.LastSelectedIds, m.LastUsedDialogWidth, m.SelectedComponent, m.CurrentStepSimulationStep, m.CurrentTruthTable, m.TTConfig, m.RightPaneTabVisible, m.SimSubTabVisible, m.CircuitCheck, m.Hilighted, m.Clipboard, m.LastCreatedComponent, m.SavedSheetIsOutOfDate, m.PendingDragAddition, m.DragPlacement, m.ProjectBrowser, m.TopSheetChoiceDeclined, m.ComponentLibraries, m.OpenLibrary, m.CatalogueSearch, m.ArrayCopiesTyped, m.SimulateInRenderer, m.SidecarSession, m.ProbeRead, m.SidecarInFlight, m.SidecarBuildEndedMs, m.SidecarRunEndedMs, m.StepRunTarget, m.FetchedData, m.FetchedStructure, m.FailedFetch, m.StimulusGeneration, m.CurrentViewport, m.ViewportChangedAtMs, m.WaveScrollSettling, m.WaveScrollSerial, m.ShowLibrarySheets, m.SuppressErrorPopups, m.OpenedLibrarySheets, m.ReadOnlyBaseline, new Project(project.ProjectPath, project.OpenFileName, project.WorkingFileName, updated), m.PopupViewFunc, m.SpinnerPayload, m.PopupDialogData, m.Notifications, m.TopMenuOpenState, m.SheetMenuPinned, m.DividerDragMode, m.WaveSimViewerWidth, m.ConnsOfSelectedWavesAreHighlighted, m.Pending, m.UIState, m.BuildVisible, m.CodeEditorState))]));
        updateComponents(withLoopVariable(model, defaultArg((option_3 = ((option_1 = tryFind((ldc) => (ldc.Name === openName), updated), (option_1 != null) ? option_1.LCParameterSlots : undefined)), (option_3 != null) ? bindingsOf(option_3.DefaultBindings) : undefined), empty({
            Compare: (x, y) => (compare(x, y) | 0),
        }))), model, dispatch);
    }
}

/**
 * Give each pasted component the parameter slot expressions of the component it was copied from,
 * so that a pasted copy stays parameterised rather than freezing at whatever value it was
 * showing. Slots are keyed by component id, and a paste mints new ids, so without this the
 * parameterisation is silently lost.
 * A slot is only copied when every parameter it refers to is declared on this sheet: pasting
 * into a sheet that does not declare them would otherwise leave a slot referring to nothing,
 * which breaks the invariant that every parameter used on a sheet is defined on it.
 */
export function copyParamSlotsToPastedComponents(pairs, model) {
    let value_4, option_4;
    const slots = defaultArg(Optic_Get_op_HatDot_Z32FCD1E1(Optic_Get.Get, paramSlotsOfModel_)(model), empty({
        Compare: (x, y) => (compare(x, y) | 0),
    }));
    const declared = defaultArg(Optic_Get_op_HatDot_Z32FCD1E1(Optic_Get.Get, defaultBindingsOfModel_)(model), empty({
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    }));
    const isDeclaredHere = (name) => containsKey(name, declared);
    const pastedIds = ofList_1(map((tuple) => tuple[1], pairs), {
        Compare: (x_2, y_2) => (compare(x_2, y_2) | 0),
    });
    const copied = collect((tupledArg) => map((tupledArg_2) => [new ParamSlot(tupledArg[1], tupledArg_2[0].CompSlot), tupledArg_2[1]], filter_1((tupledArg_1) => {
        if (equals(tupledArg_1[0].CompId, tupledArg[0])) {
            return forAll(isDeclaredHere, paramNamesOfSlot(tupledArg_1[1]));
        }
        else {
            return false;
        }
    }, toList_1(slots))), pairs);
    let withSlots;
    if (isEmpty(copied)) {
        withSlots = model;
    }
    else {
        const slots$0027 = fold((acc, tupledArg_3) => add(tupledArg_3[0], tupledArg_3[1], acc), slots, copied);
        withSlots = Optic_Set_op_HatEquals_Z32E30375(Optic_Set.Set$, paramSlotsOfModel_)(slots$0027)(model);
    }
    const pruned = map_2((_arg_1, sym_1) => {
        let bind$0040;
        const matchValue = contains(sym_1.Component.Id, pastedIds);
        const matchValue_1 = sym_1.Component.Type;
        let matchResult;
        if (matchValue) {
            if (matchValue_1.tag === 26) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                const cc = matchValue_1.fields[0];
                const bindings_1 = defaultArg(cc.ParameterBindings, empty({
                    Compare: (x_3, y_3) => (compare(x_3, y_3) | 0),
                }));
                const kept_1 = filter_2((_arg_2, expr) => forAll(isDeclaredHere, paramNamesOfExpr(expr)), bindings_1);
                if (count_1(kept_1) === count_1(bindings_1)) {
                    return [sym_1, empty_2()];
                }
                else {
                    return [new DrawModelType_SymbolT_Symbol(sym_1.Pos, sym_1.CentrePos, sym_1.OffsetFromBBCentre, sym_1.InWidth0, sym_1.InWidth1, sym_1.InWidths, sym_1.LabelBoundingBox, sym_1.LabelHasDefaultPos, sym_1.LabelRotation, sym_1.Appearance, sym_1.Id, (bind$0040 = sym_1.Component, new Component_1(bind$0040.Id, new ComponentType(/* Custom */ 26, [new CustomComponentType(cc.Name, cc.InputLabels, cc.OutputLabels, cc.Form, isEmpty_1(kept_1) ? undefined : kept_1, cc.Description)]), bind$0040.Label, bind$0040.InputPorts, bind$0040.OutputPorts, bind$0040.X, bind$0040.Y, bind$0040.H, bind$0040.W, bind$0040.SymbolInfo, bind$0040.SlotInfo)), sym_1.Annotation, sym_1.Moving, sym_1.IsClocked, sym_1.STransform, sym_1.ReversedInputPorts, sym_1.PortMaps, sym_1.HScale, sym_1.VScale, sym_1.MovingPort, sym_1.MovingPortTarget, sym_1.ArrayText), map((_arg) => [sym_1.Component.Label, _arg.fields[0]], filter_1((name_1) => !containsKey(name_1, kept_1), map((tuple_1) => tuple_1[0], toList_1(bindings_1))))];
                }
            }
            default:
                return [sym_1, empty_2()];
        }
    }, Optic_Get_op_HatDot_Z146BA564(Optic_Get.Get, modelToSymbols)(withSlots));
    const dropped = collect((arg_5) => arg_5[1][1], toList_1(pruned));
    const model$0027 = ((value_4 = map_2((_arg_3, tupledArg_4) => tupledArg_4[0], pruned), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, modelToSymbols)(value_4)))(withSlots);
    if (isEmpty(dropped)) {
        return model$0027;
    }
    else {
        const described = StringModule_Concat("; ", map((tupledArg_5) => concat(tupledArg_5[0], " (", StringModule_Concat(", ", map((tuple_5) => tuple_5[1], tupledArg_5[1])), ")"), List_groupBy((tuple_4) => tuple_4[0], dropped, {
            Equals: (x_4, y_4) => (x_4 === y_4),
            GetHashCode: (x_4) => (stringHash(x_4) | 0),
        })));
        const sheetName = defaultArg((option_4 = model.CurrentProj, (option_4 != null) ? option_4.OpenFileName : undefined), "this sheet");
        return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, fromDiagram_)(notifications_))((dispatch) => warningNotification(`Pasted here, these components lost parameter bindings that ${sheetName} does not declare, and now use the default values of the sheets inside them: ${described}.`, Msg.CloseDiagramNotification, dispatch))(model$0027);
    }
}

/**
 * Declare a parameter on the open sheet, change what it is declared as, or delete it.
 * 
 * The one path that writes what a sheet DECLARES. It used to take a discriminated union choosing
 * between this and writing a slot, but nothing ever constructed the second case: slots are
 * written by updateParamSlot, through the model, which is where the properties boxes already are.
 * 
 * The sheet's parameter data is reached through lcParameterDefs_, so a sheet that declares
 * nothing yet needs no special case: it reads as empty and writing to it creates the record.
 */
export function modifyDeclaredParam(project, paramName, change, dispatch) {
    const newProject = new Project(project.ProjectPath, project.OpenFileName, project.WorkingFileName, map((lc) => {
        const matchValue = lc.Name === project.OpenFileName;
        if (matchValue) {
            return Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, defaultBindings_)(lcParameterDefs_))(change)(lc);
        }
        else {
            return lc;
        }
    }, project.LoadedComponents));
    dispatch(new Msg(/* UpdateModel */ 41, [(arg_3) => {
        let model;
        return markSheetParamsChanged((model = arg_3, new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, newProject, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState)));
    }]));
    dispatch(Msg.PropagateParameters);
}

/**
 * Declare a parameter, or replace what it is declared as.
 */
export function setDeclaredParam(project, paramName, value, description, dispatch) {
    let value_1;
    modifyDeclaredParam(project, paramName, (value_1 = (new ParamDefinition(new ParamExpression(/* PInt */ 0, [value]), description)), (table) => add(new ParamName(paramName), value_1, table)), dispatch);
}

/**
 * Remove a parameter's declaration from the open sheet.
 */
export function removeDeclaredParam(project, paramName, dispatch) {
    modifyDeclaredParam(project, paramName, (table) => remove(new ParamName(paramName), table), dispatch);
}

/**
 * Every instance of a sheet binds every parameter that sheet declares.
 * 
 * Placing an instance establishes that - customComponentParamPopup asks for a value for each
 * parameter - but a parameter added to a sheet that ALREADY has instances would leave every one
 * of them binding nothing. An unbound parameter is a state the design deliberately does not have:
 * it elaborates at the sheet's own declared value, which is a fact about the sheet and not about
 * the instance, and it makes "default" into a concept the user has to reason about.
 * 
 * This is the mirror of removeParamFromInstances, which drops a deleted parameter's binding from
 * every instance across the project, and it works the same way: LoadedComponent canvases only,
 * since a sheet cannot instantiate itself and so the open sheet's own canvas can hold no instance
 * of it.
 * 
 * The value bound is the one just declared, so nothing about the design changes - that is exactly
 * what an unbound parameter elaborated to. What changes is that the binding exists, can be seen
 * and edited, and, being a literal, is what the bind-to-top offer fires on: following an outer
 * parameter of the same name is then offered on each instance rather than having to be found.
 * No slot is created, because a literal needs none (see updateParamSlot).
 * The work itself is ParameterAnalysis.bindParamOnInstances, which is a function of the loaded
 * components alone and so can be tested without building a Model; this only reaches it.
 */
export function addParamToInstances(sheetName, name, value, model) {
    let option_1;
    const openName = defaultArg((option_1 = model.CurrentProj, (option_1 != null) ? option_1.OpenFileName : undefined), "");
    return Optic_Map_op_HatPercent_Z32F545AB(Optic_Map.Map$, Compose_Prism_op_GreaterQmarkGreater_507FA136(Compose_Prism.Prism, loadedComponents_)(projectOpt_))((arg_2) => saveDirtyClosedSheets(openName, bindParamOnInstances(sheetName, name, value, arg_2)))(model);
}

function instanceCountOf(sheetName, project) {
    return sumBy((ldc_1) => (length(filter_1((comp) => {
        const matchValue = comp.Type;
        if (matchValue.tag === 26) {
            return matchValue.fields[0].Name === sheetName;
        }
        else {
            return false;
        }
    }, ldc_1.CanvasState[0])) | 0), filter_1((ldc) => (ldc.Name !== sheetName), project.LoadedComponents), {
        GetZero: () => 0,
        Add: (x, y) => ((x + y) | 0),
    }) | 0;
}

/**
 * Creates a popup that allows a parameter integer value to be added.
 */
export function addParameterBox(model, dispatch) {
    let option_1;
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        const defaultVal = fromOne();
        const declaredNames = defaultArg((option_1 = tryFind((lc) => (lc.Name === project.OpenFileName), project.LoadedComponents), (option_1 != null) ? map((arg_1) => arg_1[0].fields[0], toList_1(getDefaultParamDefs(option_1))) : undefined), empty_2());
        const nameIsTaken = (name) => contains_1(name, declaredNames, {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        });
        dialogPopup("Add property", dialogPopupBodyTextDescriptionAndInt((_arg) => {
            const children = ["Specify the property name:", react.createElement("br", {})];
            return react.createElement("div", {}, ...children);
        }, "example: x", (_arg_1) => {
            const children_2 = ["What does this property mean?", react.createElement("br", {})];
            return react.createElement("div", {}, ...children_2);
        }, "example: width of the data bus in bits", (_arg_2) => {
            const children_4 = ["Default value for the property:", react.createElement("br", {})];
            return react.createElement("div", {}, ...children_4);
        }, defaultVal, nameIsTaken, dispatch), "Add property", (model$0027) => {
            const newParamName = getText(model$0027.PopupDialogData);
            const newValue = getInt2(model$0027.PopupDialogData);
            setDeclaredParam(project, newParamName, newValue, getText2(model$0027.PopupDialogData), dispatch);
            const sheetName = project.OpenFileName;
            dispatch(new Msg(/* UpdateModel */ 41, [(model_1) => addParamToInstances(sheetName, new ParamName(newParamName), newValue, model_1)]));
            const matchValue_1 = instanceCountOf(sheetName, project) | 0;
            if (matchValue_1 === 0) {
            }
            else {
                const n_1 = matchValue_1 | 0;
                dispatch(new Msg(/* SetPropertiesNotification */ 83, [successPropertiesNotification(`${n_1} ${(n_1 === 1) ? "instance" : "instances"} of ${sheetName} now use ${newParamName} = ${newValue}. Their properties offer connecting it to a property of an enclosing sheet.`)]));
            }
            dispatch(Msg.ClosePopup);
        }, (model$0027_1) => {
            const newParamName_1 = getText(model$0027_1.PopupDialogData);
            if ((!isValidParamName(newParamName_1) ? true : nameIsTaken(newParamName_1)) ? true : (getText2(model$0027_1.PopupDialogData) === "")) {
                return true;
            }
            else {
                return model$0027_1.PopupDialogData.Int2 == null;
            }
        }, empty_2(), dispatch);
    }
    else {
        warn("addParameterBox called when no project is currently open");
    }
}

/**
 * Creates a popup that allows a parameter integer value to be edited.
 * TODO: this should be a special cases of a more general popup for parameter expressions?
 */
export function editParameterBox(model, parameterName, dispatch) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        const matchValue_1 = tryFind_1(new ParamName(parameterName), getDefaultParamDefs(find((lc) => (lc.Name === project.OpenFileName), project.LoadedComponents)));
        if (matchValue_1 != null) {
            if (!(matchValue_1.Expression.tag === 0)) {
                const expr_1 = matchValue_1.Expression;
                dispatch(new Msg(/* SetPropertiesNotification */ 83, [errorPropsNotification(concat(parameterName, " is set to an expression. Only whole-number property values can be edited here."))]));
            }
            else {
                const currentDef = matchValue_1;
                const currentValue = currentDef.Expression;
                const defaultVal = (currentValue.tag === 0) ? currentValue.fields[0] : fromOne();
                const editedBindings = (model$0027) => {
                    let table_1;
                    return bindingsOf((table_1 = getLCParamInfo(model$0027).DefaultBindings, add(new ParamName(parameterName), new ParamDefinition(new ParamExpression(/* PInt */ 0, [getInt2(model$0027.PopupDialogData)]), getText2(model$0027.PopupDialogData)), table_1)));
                };
                const slotSpecs = (model$0027_1) => choose((tupledArg) => {
                    const slot = tupledArg[0];
                    const option_2 = tryFind_1(slot.CompId, model$0027_1.Sheet.Wire.Symbol.Symbols);
                    if (option_2 != null) {
                        return new ConstrainedExpr(tupledArg[1].Expression, constraintsFor(slot.CompSlot, option_2.Component.Type));
                    }
                    else {
                        return undefined;
                    }
                }, toList_1(defaultArg(Optic_Get_op_HatDot_Z32FCD1E1(Optic_Get.Get, paramSlotsOfModel_)(model$0027_1), empty({
                    Compare: (x, y) => (compare(x, y) | 0),
                }))));
                dispatch(new Msg(/* SetPopupDialogText2 */ 53, [currentDef.Description]));
                dialogPopup("Edit property", dialogPopupBodyDescriptionAndInt((_arg) => {
                    const children = [concat("What does ", parameterName, " mean?"), react.createElement("br", {})];
                    return react.createElement("div", {}, ...children);
                }, currentDef.Description, (_arg_1) => {
                    const children_2 = [concat("Value of ", parameterName, " when this sheet has no instances:"), react.createElement("br", {}), `(currently ${currentValue})`, react.createElement("br", {}), "Each place this sheet is used gives its own value, and those are edited on the instance."];
                    return react.createElement("div", {}, ...children_2);
                }, defaultVal, (model$0027_2) => {
                    if (model$0027_2.PopupDialogData.Int2 != null) {
                        const matchValue_3 = evaluateConstraints(editedBindings(model$0027_2), slotSpecs(model$0027_2));
                        if (matchValue_3.tag === 1) {
                            if (!isEmpty(matchValue_3.fields[0])) {
                                const firstConstraint = head(matchValue_3.fields[0]);
                                let err;
                                if (firstConstraint.tag === 1) {
                                    err = firstConstraint.fields[1];
                                }
                                else {
                                    err = firstConstraint.fields[1];
                                }
                                return err;
                            }
                            else {
                                return undefined;
                            }
                        }
                        else {
                            return undefined;
                        }
                    }
                    else {
                        return undefined;
                    }
                }, dispatch), "Set value", (model$0027_3) => {
                    setDeclaredParam(project, parameterName, getInt2(model$0027_3.PopupDialogData), getText2(model$0027_3.PopupDialogData), dispatch);
                    updateComponents(withLoopVariable(model, editedBindings(model$0027_3)), model, dispatch);
                    dispatch(Msg.ClosePopup);
                }, (model$0027_4) => {
                    if ((model$0027_4.PopupDialogData.Int2 == null) ? true : (getText2(model$0027_4.PopupDialogData) === "")) {
                        return true;
                    }
                    else {
                        return Result_IsError(evaluateConstraints(editedBindings(model$0027_4), slotSpecs(model$0027_4)));
                    }
                }, empty_2(), dispatch);
            }
        }
        else {
            warn(concat("Cannot edit parameter ", parameterName, ": it is not defined on this sheet"));
        }
    }
    else {
        warn("editParameterBox called when no project is currently open");
    }
}

/**
 * What a slot is called where the user has to recognise it: the field of the component that the
 * expression fills. Written once, because the message that refuses to delete a property and the
 * table of parameterised components both name the same thing and had drifting copies of this.
 * 
 * "Width", not "Buswidth": the properties box it names is labelled "Width (bits)", and the
 * developer's word for the slot means nothing to whoever is being asked to go and change it.
 */
export function slotFieldName(slot) {
    switch (slot.tag) {
        case 1:
            return concat("Input/output ", slot.fields[0]);
        case 3:
            return `SplitN output ${slot.fields[0]} width`;
        case 4:
            return `SplitN output ${slot.fields[0]} LSB`;
        case 2:
            return concat("Property ", slot.fields[0]);
        case 5:
            return "Default value";
        case 6:
            return "Address width";
        case 7:
            return "Data width";
        case 8:
            return "Channel number";
        default:
            return "Width";
    }
}

/**
 * Human readable name of the slot a parameter expression fills, for use in messages.
 */
export function describeSlot(model, slot) {
    const slotName = slotFieldName(slot.CompSlot);
    const matchValue = tryFind_1(slot.CompId, model.Sheet.Wire.Symbol.Symbols);
    if (matchValue == null) {
        return concat("[deleted component]: ", slotName);
    }
    else {
        return concat(matchValue.Component.Label, ": ", slotName);
    }
}

/**
 * A binding of a parameter of `sheetName` on an instance of that sheet no longer means anything
 * once the parameter has gone, so drop it from every other sheet in the project.
 * Bindings live in two places: the instance's own ParameterBindings, and a CustomCompParam slot
 * of the sheet the instance sits on.
 */
export function removeParamFromInstances(sheetName, name, model) {
    let option_4;
    const openName = defaultArg((option_4 = model.CurrentProj, (option_4 != null) ? option_4.OpenFileName : undefined), "");
    return Optic_Map_op_HatPercent_Z32F545AB(Optic_Map.Map$, Compose_Prism_op_GreaterQmarkGreater_507FA136(Compose_Prism.Prism, loadedComponents_)(projectOpt_))((ldcs) => saveDirtyClosedSheets(openName, map((ldc_1) => {
        let mapping_2, option_2;
        if (ldc_1.Name === sheetName) {
            return ldc_1;
        }
        else {
            const ldc = ldc_1;
            const patternInput = ldc.CanvasState;
            const comps = patternInput[0];
            const instanceIds = ofList_1(map((comp_2) => comp_2.Id, filter_1((comp) => {
                const matchValue = comp.Type;
                if (matchValue.tag === 26) {
                    return matchValue.fields[0].Name === sheetName;
                }
                else {
                    return false;
                }
            }, comps)), {
                Compare: (x, y) => (compare(x, y) | 0),
            });
            const ldc$0027 = new LoadedComponent(ldc.Name, ldc.TimeStamp, ldc.FilePath, ldc.WaveInfo, [map((comp_1) => {
                let option, custom_1;
                const matchValue_1 = comp_1.Type;
                let matchResult, custom_2;
                if (matchValue_1.tag === 26) {
                    if ((custom_1 = matchValue_1.fields[0], (custom_1.Name === sheetName) && exists((table) => containsKey(name, table), toArray(custom_1.ParameterBindings)))) {
                        matchResult = 0;
                        custom_2 = matchValue_1.fields[0];
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return new Component_1(comp_1.Id, new ComponentType(/* Custom */ 26, [new CustomComponentType(custom_2.Name, custom_2.InputLabels, custom_2.OutputLabels, custom_2.Form, (option = custom_2.ParameterBindings, (option != null) ? remove(name, option) : undefined), custom_2.Description)]), comp_1.Label, comp_1.InputPorts, comp_1.OutputPorts, comp_1.X, comp_1.Y, comp_1.H, comp_1.W, comp_1.SymbolInfo, comp_1.SlotInfo);
                    default:
                        return comp_1;
                }
            }, comps), patternInput[1]], ldc.InputLabels, ldc.OutputLabels, (mapping_2 = Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, paramSlots_)((slots) => filter_2((slot, _arg) => {
                const matchValue_2 = slot.CompSlot;
                if (matchValue_2.tag === 2) {
                    return !((matchValue_2.fields[0] === name.fields[0]) && contains(slot.CompId, instanceIds));
                }
                else {
                    return true;
                }
            }, slots)), (option_2 = ldc.LCParameterSlots, (option_2 != null) ? mapping_2(option_2) : undefined)), ldc.Form, ldc.LoadedComponentIsOutOfDate, ldc.Description, ldc.IsTopSheet, ldc.ArrayInfo);
            if (equalArrays(ldc$0027.CanvasState, ldc.CanvasState) && equals(ldc$0027.LCParameterSlots, ldc.LCParameterSlots)) {
                return ldc;
            }
            else {
                return new LoadedComponent(ldc$0027.Name, ldc$0027.TimeStamp, ldc$0027.FilePath, ldc$0027.WaveInfo, ldc$0027.CanvasState, ldc$0027.InputLabels, ldc$0027.OutputLabels, ldc$0027.LCParameterSlots, ldc$0027.Form, true, ldc$0027.Description, ldc$0027.IsTopSheet, ldc$0027.ArrayInfo);
            }
        }
    }, ldcs)))(model);
}

/**
 * Delete a sheet parameter. A slot referring to a parameter that does not exist is an undefined
 * design, so this refuses while any slot on the sheet still refers to it and says which ones.
 */
export function deleteParameterBox(model, parameterName, dispatch) {
    let props_4, children_2;
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        const name = new ParamName(parameterName);
        const sheet = getCurrentSheet(model);
        const users = filter_1((tupledArg) => containsKey(tupledArg[0].CompId, model.Sheet.Wire.Symbol.Symbols), slotsUsingParam(name, getParamSlots(sheet)));
        if (isEmpty(users)) {
            removeDeclaredParam(project, parameterName, dispatch);
            dispatch(new Msg(/* UpdateModel */ 41, [(model_1) => removeParamFromInstances(sheet.Name, name, model_1)]));
        }
        else {
            let body;
            const children_4 = [concat("Property ", parameterName, " cannot be deleted because it is still used by the following component slots on this sheet:"), react.createElement("br", {}), (props_4 = [["style", {
                marginLeft: "20px",
                listStyleType: "disc",
            }]], (children_2 = map((tupledArg_1) => {
                const children = [describeSlot(model, tupledArg_1[0])];
                return react.createElement("li", {}, ...children);
            }, users), react.createElement("ul", keyValueList(props_4, 1), ...children_2))), react.createElement("br", {}), "Give each of them a value that does not use this property, then delete it."];
            body = react.createElement("div", {}, ...children_4);
            closablePopup(concat("Cannot delete property ", parameterName), body, react.createElement("div", {}), empty_2(), dispatch);
        }
    }
    else {
        warn("deleteParameterBox called when no project is currently open");
    }
}

function makeParamsField(model, comp, dispatch) {
    let children_22;
    const sheetDefaultParams = getDefaultParamDefs(comp);
    const simIsOpen = simulationIsOpen(model);
    let simWarning;
    if (simIsOpen) {
        const props_2 = [["style", {
            color: "red",
        }]];
        simWarning = react.createElement("p", keyValueList(props_2, 1), "Close all simulations to change the properties of this sheet.");
    }
    else {
        simWarning = react.createElement("div", {});
    }
    let displayValues;
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const ldcs = getUpdatedLoadedComponents(matchValue, model).LoadedComponents;
        displayValues = displayValues_1(ldcs, effectiveTopSheetFor(ldcs, comp.Name), comp.Name);
    }
    else {
        displayValues = empty({
            Compare: (x, y) => (compare(x, y) | 0),
        });
    }
    const addParameterButton = button(ofArray([new Option_2(/* OnClick */ 18, [(_arg_1) => {
        let option_1;
        if (defaultArg((option_1 = model.CurrentProj, (option_1 != null) ? projectDeclaresParams(option_1.LoadedComponents) : undefined), false)) {
            addParameterBox(model, dispatch);
        }
        else {
            confirmationPopup("Using properties", "Add a property", helpText(Confirm_usingParameters), () => {
                dispatch(Msg.ClosePopup);
                addParameterBox(model, dispatch);
            }, dispatch);
        }
    }]), new Option_2(/* Color */ 0, [Color_IColor.IsInfo]), new Option_2(/* Disabled */ 16, [simIsOpen])]), singleton("Add Property"));
    if (FSharpMap__get_IsEmpty(sheetDefaultParams)) {
        return react.createElement("div", {}, simWarning, addParameterButton);
    }
    else {
        const children_24 = [label_1(empty_2(), singleton("Properties this sheet declares")), simWarning, (children_22 = map((tupledArg) => {
            let children_16, matchValue_3, children_18;
            const key_1 = tupledArg[0];
            const definition = tupledArg[1];
            const paramName = key_1.fields[0];
            let patternInput;
            const storedText = renderParamExpression(definition.Expression, 0);
            const matchValue_1 = tryFind_1(key_1, displayValues);
            let matchResult, largest, others;
            if (matchValue_1 != null) {
                if (matchValue_1.tag === 1) {
                    if (!isEmpty(matchValue_1.fields[0])) {
                        matchResult = 0;
                        largest = head(matchValue_1.fields[0]);
                        others = tail(matchValue_1.fields[0]);
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    patternInput = [isEmpty(others) ? toString(largest) : (`${largest} (also ${StringModule_Concat(", ", map(toString, truncate(2, others)))}${(length(others) > 2) ? ", ..." : ""})`), true];
                    break;
                }
                default:
                    patternInput = [storedText, false];
            }
            const paramVal = patternInput[0];
            const isSettled = patternInput[1];
            const line = (fieldName, valueEl) => {
                let children_6;
                return ofArray([(children_6 = [concat(fieldName, ":")], react.createElement("span", {
                    className: "propertyLabel",
                }, ...children_6)), valueEl]);
            };
            let valueSpan;
            if (isSettled) {
                valueSpan = react.createElement("span", {
                    className: "propertyValue",
                }, paramVal);
            }
            else {
                const props_10 = [new HTMLAttr(/* Class */ 65, [`propertyValue isPlaceholder ${"tooltip"} ${"has-tooltip-left"} ${"has-tooltip-multiline"}`]), dataTooltip("Nothing uses this sheet yet, so this value is only a placeholder. It is replaced by whatever a design gives the property once the sheet is used in one.")];
                valueSpan = react.createElement("span", keyValueList(props_10, 1), paramVal);
            }
            const children_20 = [(children_16 = append(line("Property name", react.createElement("span", {
                className: "propertyName",
            }, paramName)), append((matchValue_3 = definition.Description, (matchValue_3 === "") ? empty_2() : line("Description", react.createElement("span", {
                className: "propertyMeans",
            }, matchValue_3))), line("Value", valueSpan))), react.createElement("div", {
                className: "propertyFields",
            }, ...children_16)), (children_18 = toList(delay(() => append_1(!isSettled ? singleton_1(button(ofArray([new Option_2(/* OnClick */ 18, [(_arg_2) => {
                editParameterBox(model, paramName, dispatch);
            }]), new Option_2(/* Color */ 0, [Color_IColor.IsInfo]), new Option_2(/* Size */ 1, [Size_ISize.IsSmall]), new Option_2(/* Disabled */ 16, [simIsOpen])]), singleton("Edit Property"))) : empty_1(), delay(() => singleton_1(button(ofArray([new Option_2(/* OnClick */ 18, [(_arg_3) => {
                deleteParameterBox(model, paramName, dispatch);
            }]), new Option_2(/* Color */ 0, [Color_IColor.IsDanger]), new Option_2(/* Size */ 1, [Size_ISize.IsSmall]), new Option_2(/* Disabled */ 16, [simIsOpen])]), singleton("Delete Property"))))))), react.createElement("div", {
                className: "propertyControls",
            }, ...children_18))];
            return react.createElement("div", {
                key: paramName,
                className: "propertyBlock",
            }, ...children_20);
        }, toList_1(sheetDefaultParams)), react.createElement("div", {}, ...children_22)), addParameterButton];
        return react.createElement("div", {}, ...children_24);
    }
}

const emptyParamDefs = new ParameterDefs(empty({
    Compare: (x, y) => (compare(x, y) | 0),
}), empty({
    Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
}));

function applyChainActionToLdc(action, ldc) {
    let matchResult, defVal_1, description_1, name_2, sheet_2, instId_1, name_3, sheet_3;
    if (action.tag === 1) {
        if (action.fields[0] === ldc.Name) {
            matchResult = 1;
            instId_1 = action.fields[1];
            name_3 = action.fields[4];
            sheet_3 = action.fields[0];
        }
        else {
            matchResult = 2;
        }
    }
    else if (action.fields[0] === ldc.Name) {
        matchResult = 0;
        defVal_1 = action.fields[2];
        description_1 = action.fields[3];
        name_2 = action.fields[1];
        sheet_2 = action.fields[0];
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0: {
            const defs = defaultArg(ldc.LCParameterSlots, emptyParamDefs);
            if (containsKey(name_2, defs.DefaultBindings)) {
                return ldc;
            }
            else {
                return new LoadedComponent(ldc.Name, ldc.TimeStamp, ldc.FilePath, ldc.WaveInfo, ldc.CanvasState, ldc.InputLabels, ldc.OutputLabels, new ParameterDefs(add(name_2, new ParamDefinition(new ParamExpression(/* PInt */ 0, [defVal_1]), description_1), defs.DefaultBindings), defs.ParamSlots), ldc.Form, ldc.LoadedComponentIsOutOfDate, ldc.Description, ldc.IsTopSheet, ldc.ArrayInfo);
            }
        }
        case 1: {
            const defs_1 = defaultArg(ldc.LCParameterSlots, emptyParamDefs);
            const defs$0027 = new ParameterDefs(defs_1.DefaultBindings, add(new ParamSlot(instId_1, new CompSlotName(/* CustomCompParam */ 2, [name_3.fields[0]])), new ConstrainedExpr(new ParamExpression(/* PParameter */ 1, [name_3]), empty_2()), defs_1.ParamSlots));
            const patternInput = ldc.CanvasState;
            return new LoadedComponent(ldc.Name, ldc.TimeStamp, ldc.FilePath, ldc.WaveInfo, [map((c) => {
                const matchValue_1 = equals(c.Id, instId_1);
                const matchValue_2 = c.Type;
                let matchResult_1;
                if (matchValue_1) {
                    if (matchValue_2.tag === 26) {
                        matchResult_1 = 0;
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
                switch (matchResult_1) {
                    case 0: {
                        const cc = matchValue_2.fields[0];
                        return new Component_1(c.Id, new ComponentType(/* Custom */ 26, [new CustomComponentType(cc.Name, cc.InputLabels, cc.OutputLabels, cc.Form, add(name_3, new ParamExpression(/* PParameter */ 1, [name_3]), defaultArg(cc.ParameterBindings, empty({
                            Compare: (x, y) => (compare(x, y) | 0),
                        }))), cc.Description)]), c.Label, c.InputPorts, c.OutputPorts, c.X, c.Y, c.H, c.W, c.SymbolInfo, c.SlotInfo);
                    }
                    default:
                        return c;
                }
            }, patternInput[0]), patternInput[1]], ldc.InputLabels, ldc.OutputLabels, defs$0027, ldc.Form, ldc.LoadedComponentIsOutOfDate, ldc.Description, ldc.IsTopSheet, ldc.ArrayInfo);
        }
        default:
            return ldc;
    }
}

/**
 * Apply accepted bind-to-top offers: create the parameters and bindings of their chains,
 * update the open sheet's symbols to match, and persist. A sheet whose file was in step with
 * memory is written through immediately; the open sheet (whose canvas belongs to the draw
 * block) is marked as needing saving instead, so accepting an offer never silently commits
 * unrelated circuit edits.
 */
export function applyBindOffers(offers, model, dispatch) {
    let option_3, option_1;
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        const actions = List_distinct(collect((offer) => offer.Actions, offers), {
            Equals: equals,
            GetHashCode: (x) => (safeHash(x) | 0),
        });
        const modifiedSheets = ofList_1(collect(sheetsModifiedByOffer, offers), {
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        });
        const openName = project.OpenFileName;
        const ldcs$0027 = saveDirtyClosedSheets(openName, map((ldc) => {
            const matchValue_1 = contains(ldc.Name, modifiedSheets);
            if (matchValue_1) {
                const ldc$0027 = fold((l, action) => applyChainActionToLdc(action, l), ldc, actions);
                return new LoadedComponent(ldc$0027.Name, ldc$0027.TimeStamp, ldc$0027.FilePath, ldc$0027.WaveInfo, ldc$0027.CanvasState, ldc$0027.InputLabels, ldc$0027.OutputLabels, ldc$0027.LCParameterSlots, ldc$0027.Form, true, ldc$0027.Description, ldc$0027.IsTopSheet, ldc$0027.ArrayInfo);
            }
            else {
                return ldc;
            }
        }, project.LoadedComponents));
        dispatch(new Msg(/* UpdateModel */ 41, [(m) => {
            const m$0027 = new Model(m.WindowWidth, m.KeyFocusPane, m.RunAfterRenderWithSpinner, m.UserData, m.WaveSim, m.WaveSimSheet, m.UISheetTrail, m.Spinner, m.Sheet, m.IsLoading, m.LastChangeCheckTime, m.LastSimulatedCanvasState, m.LastDetailedSavedState, m.CurrentSelected, m.LastSelectedIds, m.LastUsedDialogWidth, m.SelectedComponent, m.CurrentStepSimulationStep, m.CurrentTruthTable, m.TTConfig, m.RightPaneTabVisible, m.SimSubTabVisible, m.CircuitCheck, m.Hilighted, m.Clipboard, m.LastCreatedComponent, m.SavedSheetIsOutOfDate, m.PendingDragAddition, m.DragPlacement, m.ProjectBrowser, m.TopSheetChoiceDeclined, m.ComponentLibraries, m.OpenLibrary, m.CatalogueSearch, m.ArrayCopiesTyped, m.SimulateInRenderer, m.SidecarSession, m.ProbeRead, m.SidecarInFlight, m.SidecarBuildEndedMs, m.SidecarRunEndedMs, m.StepRunTarget, m.FetchedData, m.FetchedStructure, m.FailedFetch, m.StimulusGeneration, m.CurrentViewport, m.ViewportChangedAtMs, m.WaveScrollSettling, m.WaveScrollSerial, m.ShowLibrarySheets, m.SuppressErrorPopups, m.OpenedLibrarySheets, m.ReadOnlyBaseline, new Project(project.ProjectPath, project.OpenFileName, project.WorkingFileName, ldcs$0027), m.PopupViewFunc, m.SpinnerPayload, m.PopupDialogData, m.Notifications, m.TopMenuOpenState, m.SheetMenuPinned, m.DividerDragMode, m.WaveSimViewerWidth, m.ConnsOfSelectedWavesAreHighlighted, m.Pending, m.UIState, m.BuildVisible, m.CodeEditorState);
            return contains(openName, modifiedSheets) ? Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, savedSheetIsOutOfDate_)(true)(m$0027) : m$0027;
        }]));
        const openDefaults = defaultArg((option_3 = ((option_1 = tryFind((ldc_1) => (ldc_1.Name === openName), ldcs$0027), (option_1 != null) ? option_1.LCParameterSlots : undefined)), (option_3 != null) ? bindingsOf(option_3.DefaultBindings) : undefined), empty({
            Compare: (x_2, y_2) => (compare(x_2, y_2) | 0),
        }));
        iterate((tupledArg) => {
            const _arg = tupledArg[0];
            const names = List_distinct(map((tuple_1) => tuple_1[1], tupledArg[1]), {
                Equals: equals,
                GetHashCode: (x_4) => (safeHash(x_4) | 0),
            });
            const matchValue_3 = tryFind_1(_arg[0], model.Sheet.Wire.Symbol.Symbols);
            if (matchValue_3 != null) {
                const comp = matchValue_3.Component;
                const matchValue_4 = comp.Type;
                if (matchValue_4.tag === 26) {
                    const newBindings = fold((bindings, name_2) => add(name_2, new ParamExpression(/* PParameter */ 1, [name_2]), bindings), defaultArg(matchValue_4.fields[0].ParameterBindings, empty({
                        Compare: (x_5, y_5) => (compare(x_5, y_5) | 0),
                    })), names);
                    dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* ChangeCustom */ 26, [comp.Id, comp, updateCustomComponent(portWidthsOfInstance(ldcs$0027, openDefaults, _arg[1], newBindings), newBindings, comp).Type])])])]));
                }
            }
        }, List_groupBy((tuple) => tuple[0], choose((action_1) => {
            let matchResult, childSheet_1, instId_1, name_1, sheet_1;
            if (action_1.tag === 1) {
                if (action_1.fields[0] === openName) {
                    matchResult = 0;
                    childSheet_1 = action_1.fields[3];
                    instId_1 = action_1.fields[1];
                    name_1 = action_1.fields[4];
                    sheet_1 = action_1.fields[0];
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return [[instId_1, childSheet_1], name_1];
                default:
                    return undefined;
            }
        }, actions), {
            Equals: equalArrays,
            GetHashCode: (x_3) => (arrayHash(x_3) | 0),
        }));
        DrawModelType_SheetT_Model__Model_DoBusWidthInference_Z1E9EDA9D(model.Sheet, (sMsg) => {
            dispatch(new Msg(/* Sheet */ 3, [sMsg]));
        });
    }
}

export function paramPrompt(nameStr, definition) {
    const matchValue = definition.Description;
    if (matchValue === "") {
        return nameStr;
    }
    else {
        return concat(nameStr, ": ", matchValue);
    }
}

/**
 * The values one custom component instance supplies for the parameters of the sheet inside it.
 * 
 * One block per property, exactly as a built-in component's width is edited: an instance of a
 * sheet is not a different kind of thing from a Register, and the pane should not make it look
 * like one. Each block heads itself with the property's name and its declared description -
 * compulsory precisely so that it can be read where the value is chosen.
 * 
 * The name is the CHILD sheet's name for the property, and identifies which slot is being set; it
 * is not a name that can be used in the box, since an instance binding is an expression in the
 * properties of the sheet the instance SITS ON. It is shown because a block with a description
 * and no name says nothing about which of several properties is being set.
 * 
 * Properties come out in Map order, which is alphabetical by name. With one property - the case
 * component libraries are built around - there is nothing to order. With several the sequence is
 * arbitrary from the user's side, and nothing records an authored order to use instead; that is
 * accepted rather than solved.
 */
export function makeParamBindingEntryBoxes(model, comp, custom, dispatch) {
    let option_4, option_2, matchValue_5;
    const ccParams = defaultArg(custom.ParameterBindings, empty({
        Compare: (x, y) => (compare(x, y) | 0),
    }));
    const childDefs = defaultArg((option_4 = ((option_2 = model.CurrentProj, (option_2 != null) ? tryFind((ldc) => (ldc.Name === custom.Name), option_2.LoadedComponents) : undefined)), (option_4 != null) ? getDefaultParamDefs(option_4) : undefined), empty({
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    }));
    const slots = getParamSlots(getCurrentSheet(model));
    const bindings = paramBindingsOfModel(model);
    const ldcs = tryGetLoadedComponents(model);
    let childBindings;
    const instanceBindings = instanceBindingExprs(slots, comp, custom);
    childBindings = effectiveInstanceBindings(bindingsOf(childDefs), bindings, instanceBindings);
    const exprOf = (paramName, key) => {
        let option_7;
        return orElse((option_7 = tryFind_1(new ParamSlot(comp.Id, new CompSlotName(/* CustomCompParam */ 2, [paramName])), slots), (option_7 != null) ? option_7.Expression : undefined), tryFind_1(key, ccParams));
    };
    const valueOf = (key_1, paramName_1) => {
        const option_10 = exprOf(paramName_1, key_1);
        if (option_10 != null) {
            return Result_ToOption(evaluateParamExpression(bindings, option_10));
        }
        else {
            return undefined;
        }
    };
    const boxIsEmptyFor = (_arg) => {
        let _arg_1;
        const table = defaultArg(model.PopupDialogData.DialogState, empty({
            Compare: (x_2, y_2) => (compare(x_2, y_2) | 0),
        }));
        _arg_1 = tryFind_1(paramBoxKey(comp.Id, new CompSlotName(/* CustomCompParam */ 2, [_arg.fields[0]])), table);
        if (_arg_1 == null) {
            return false;
        }
        else {
            return _arg_1.Text === "";
        }
    };
    let bindOffers;
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        if (simulationIsOpen(model)) {
            bindOffers = empty_2();
        }
        else if (!exists_1((key_3, _arg_2) => boxIsEmptyFor(key_3), childDefs)) {
            bindOffers = empty_2();
        }
        else {
            const proj_1 = matchValue;
            const ldcs_1 = getUpdatedLoadedComponents(proj_1, model).LoadedComponents;
            bindOffers = filter_1((offer) => equals(offer.InstanceId, comp.Id), findBindOffers(ldcs_1, effectiveTopSheetFor(ldcs_1, proj_1.OpenFileName), proj_1.OpenFileName));
        }
    }
    else {
        bindOffers = empty_2();
    }
    if (isEmpty_1(childDefs)) {
        return defaultOf();
    }
    else {
        const children_8 = cons((matchValue_5 = custom.Form, (matchValue_5 != null) ? ((matchValue_5.tag === 1) ? defaultOf() : label_1(empty_2(), singleton("Property values"))) : label_1(empty_2(), singleton("Property values"))), map((tupledArg) => {
            let children_2, children_4, key_4, nameStr_1, matchValue_1, matchValue_2, offer_2;
            const key_5 = tupledArg[0];
            const def_1 = tupledArg[1];
            const paramName_2 = key_5.fields[0];
            const children_6 = [(children_2 = toList(delay(() => append_1(singleton_1(react.createElement("b", {}, paramName_2)), delay(() => ((def_1.Description !== "") ? singleton_1(concat(": ", def_1.Description)) : empty_1()))))), react.createElement("div", {
                className: "propertyHead",
            }, ...children_2)), paramInputField(model, "", defaultArg(valueOf(key_5, paramName_2), fromOne()), valueOf(key_5, paramName_2), exprOf(paramName_2, key_5), empty_2(), (value_3) => instanceBindingProblem(ldcs, custom.Name, childBindings, key_5, value_3), comp, new CompSlotName(/* CustomCompParam */ 2, [paramName_2]), dispatch), (children_4 = [(key_4 = key_5, (nameStr_1 = key_4.fields[0], (matchValue_1 = boxIsEmptyFor(key_4), (matchValue_2 = tryFind((offer_1) => equals(offer_1.Param, key_4), bindOffers), matchValue_1 ? ((matchValue_2 != null) ? ((offer_2 = matchValue_2, button(ofArray([new Option_2(/* OnClick */ 18, [(_arg_3) => {
                dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_2, dispatch_1) => {
                    applyBindOffers(singleton(offer_2), model_2, dispatch_1);
                }, dispatch]));
                dispatch(new Msg(/* ClearPopupDialogParamSpec */ 64, [paramBoxKey(comp.Id, new CompSlotName(/* CustomCompParam */ 2, [nameStr_1]))]));
            }]), new Option_2(/* Color */ 0, [Color_IColor.IsSuccess]), Option_2.IsLight]), singleton(concat("Connect this property to property ", offer_2.BindsTo, ".", nameStr_1))))) : defaultOf()) : defaultOf()))))], react.createElement("div", {
                className: "propertyControls",
            }, ...children_4))];
            return react.createElement("div", {
                key: paramName_2,
                className: "propertyBlock",
            }, ...children_6);
        }, toList_1(childDefs)));
        return react.createElement("div", {}, ...children_8);
    }
}

function childDefaultValue(childDefs, name) {
    let option_3, option_1, def;
    return defaultArg((option_3 = ((option_1 = tryFind_1(name, childDefs), (option_1 != null) ? ((def = option_1, evaluateParamExpression(bindingsOf(childDefs), def.Expression))) : undefined)), (option_3 != null) ? Result_ToOption(option_3) : undefined), fromOne());
}

/**
 * A popup asking for a value for every parameter the sheet inside a custom component declares,
 * raised when an instance is placed.
 * Placing an instance without asking would silently freeze the child sheet's defaults into it -
 * the stale-chain problem - so the choice is made explicitly instead. Where the sheet the
 * instance is being placed on declares a parameter of the same name, a button binds to that
 * parameter rather than entering a value, and the two then stay in step.
 * `place` receives the bindings to put on the instance and the slots to create for it.
 */
export function customComponentParamPopup(childLdc, place, model, dispatch) {
    let option_2;
    const childDefs = getDefaultParamDefs(childLdc);
    let patternInput;
    const matchValue = childLdc.Form;
    let matchResult, compName;
    if (matchValue != null) {
        if (matchValue.tag === 1) {
            matchResult = 0;
            compName = matchValue.fields[1];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            patternInput = [true, compName];
            break;
        }
        default:
            patternInput = [false, childLdc.Name];
    }
    const displayName = patternInput[1];
    const parentBindings = bindingsOf(defaultArg(Optic_Get_op_HatDot_Z32FCD1E1(Optic_Get.Get, defaultBindingsOfModel_)(model), empty({
        Compare: (x, y) => (compare(x, y) | 0),
    })));
    defaultArg((option_2 = model.CurrentProj, (option_2 != null) ? option_2.OpenFileName : undefined), "");
    const ldcs = cons(childLdc, filter_1((l) => (l.Name !== childLdc.Name), tryGetLoadedComponents(model)));
    const slotOf = (_arg) => (new CompSlotName(/* CustomCompParam */ 2, [_arg.fields[0]]));
    iterate((tupledArg_1) => {
        let slots, _arg_2;
        const name_3 = tupledArg_1[0];
        let spec;
        const name_1 = name_3;
        const expr = defaultArg((slots = getParamSlots(getCurrentSheet(model)), (_arg_2 = choose((tupledArg) => {
            const sym = tupledArg[1];
            const matchValue_1 = sym.Component.Type;
            let matchResult_1, cc_1;
            if (matchValue_1.tag === 26) {
                if (matchValue_1.fields[0].Name === childLdc.Name) {
                    matchResult_1 = 0;
                    cc_1 = matchValue_1.fields[0];
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return tryFind_1(name_1, instanceBindingExprs(slots, sym.Component, cc_1));
                default:
                    return undefined;
            }
        }, toList_1(Optic_Get_op_HatDot_Z146BA564(Optic_Get.Get, modelToSymbols)(model))), !isEmpty(_arg_2) ? (forAll((y_1) => equals(head(_arg_2), y_1), tail(_arg_2)) ? head(_arg_2) : undefined) : undefined)), new ParamExpression(/* PInt */ 0, [childDefaultValue(childDefs, name_1)]));
        const value_4 = defaultArg(Result_ToOption(evaluateParamExpression(parentBindings, expr)), childDefaultValue(childDefs, name_1));
        spec = (new NewParamCompSpec(slotOf(name_1), expr, empty_2(), value_4));
        dispatch(new Msg(/* AddPopupDialogParamSpec */ 63, [[paramBoxKey(undefined, slotOf(name_3)), new ParamBoxState(renderParamExpression(spec.Expression, 0), new FSharpResult$2(/* Ok */ 0, [spec]))]]));
    }, toList_1(childDefs));
    const specOf = (model$0027, name_4) => {
        let option_9;
        const table_3 = defaultArg(model$0027.PopupDialogData.DialogState, empty({
            Compare: (x_1, y_2) => (compare(x_1, y_2) | 0),
        }));
        option_9 = tryFind_1(paramBoxKey(undefined, slotOf(name_4)), table_3);
        if (option_9 != null) {
            return option_9.Spec;
        }
        else {
            return undefined;
        }
    };
    dialogPopup(patternInput[0] ? displayName : concat("Property values for ", childLdc.Name), (model$0027_2) => {
        let children_2;
        const children_4 = [concat("Property values for this instance of ", displayName, ". Each is a number, or the name of a property of an enclosing sheet so that the two stay in step."), react.createElement("br", {}), react.createElement("br", {}), (children_2 = map((tupledArg_3) => {
            let baseBindings, instanceBindings;
            const name_7 = tupledArg_3[0];
            const nameStr_1 = name_7.fields[0];
            let boxIsEmpty;
            let _arg_5;
            const table_5 = defaultArg(model$0027_2.PopupDialogData.DialogState, empty({
                Compare: (x_3, y_4) => (compare(x_3, y_4) | 0),
            }));
            _arg_5 = tryFind_1(paramBoxKey(undefined, slotOf(name_7)), table_5);
            boxIsEmpty = ((_arg_5 == null) ? false : (_arg_5.Text === ""));
            const valueEntry = paramInputField(model$0027_2, paramPrompt(nameStr_1, tupledArg_3[1]), childDefaultValue(childDefs, name_7), undefined, undefined, empty_2(), (baseBindings = ((instanceBindings = ofList(choose((tupledArg_2) => {
                const name_5 = tupledArg_2[0];
                const matchValue_2 = specOf(model$0027_2, name_5);
                let matchResult_2, spec_1;
                if (matchValue_2 != null) {
                    const copyOfStruct = matchValue_2;
                    if (copyOfStruct.tag === 0) {
                        matchResult_2 = 0;
                        spec_1 = copyOfStruct.fields[0];
                    }
                    else {
                        matchResult_2 = 1;
                    }
                }
                else {
                    matchResult_2 = 1;
                }
                switch (matchResult_2) {
                    case 0:
                        return [name_5, spec_1.Expression];
                    default:
                        return undefined;
                }
            }, toList_1(childDefs)), {
                Compare: (x_2, y_3) => (compare(x_2, y_3) | 0),
            }), effectiveInstanceBindings(bindingsOf(childDefs), parentBindings, instanceBindings))), (value_9) => instanceBindingProblem(ldcs, childLdc.Name, baseBindings, name_7, value_9)), undefined, slotOf(name_7), dispatch);
            let bindButton;
            let matchValue_4;
            const matchValue_3 = model.CurrentProj;
            if (matchValue_3 != null) {
                const proj = matchValue_3;
                const ldcs_1 = getUpdatedLoadedComponents(proj, model).LoadedComponents;
                matchValue_4 = bindOfferForPlacement(ldcs_1, effectiveTopSheetFor(ldcs_1, proj.OpenFileName), proj.OpenFileName, name_7);
            }
            else {
                matchValue_4 = undefined;
            }
            let matchResult_3;
            if (boxIsEmpty) {
                if (matchValue_4 != null) {
                    matchResult_3 = 1;
                }
                else {
                    matchResult_3 = 0;
                }
            }
            else {
                matchResult_3 = 0;
            }
            switch (matchResult_3) {
                case 0: {
                    bindButton = defaultOf();
                    break;
                }
                default:
                    bindButton = button(ofArray([new Option_2(/* Color */ 0, [Color_IColor.IsSuccess]), Option_2.IsLight, new Option_2(/* OnClick */ 18, [(_arg_6) => {
                        let name_2, value_6;
                        dispatch(new Msg(/* AddPopupDialogParamSpec */ 63, [[paramBoxKey(undefined, slotOf(name_7)), new ParamBoxState(nameStr_1, new FSharpResult$2(/* Ok */ 0, [(name_2 = name_7, (value_6 = defaultArg(Result_ToOption(evaluateParamExpression(parentBindings, new ParamExpression(/* PParameter */ 1, [name_2]))), childDefaultValue(childDefs, name_2)), new NewParamCompSpec(slotOf(name_2), new ParamExpression(/* PParameter */ 1, [name_2]), empty_2(), value_6)))]))]]));
                    }])]), singleton(concat("Connect this property to property ", matchValue_4[0], ".", nameStr_1)));
            }
            const props = [new Prop(/* Key */ 0, [nameStr_1]), ["style", {
                marginBottom: "12px",
            }]];
            return react.createElement("div", keyValueList(props, 1), valueEntry, bindButton);
        }, toList_1(childDefs)), react.createElement("div", {}, ...children_2))];
        return react.createElement("div", {}, ...children_4);
    }, "Place", (model$0027_3) => {
        const specs = choose((tupledArg_4) => {
            const matchValue_6 = specOf(model$0027_3, tupledArg_4[0]);
            let matchResult_4, spec_2;
            if (matchValue_6 != null) {
                const copyOfStruct_1 = matchValue_6;
                if (copyOfStruct_1.tag === 0) {
                    matchResult_4 = 0;
                    spec_2 = copyOfStruct_1.fields[0];
                }
                else {
                    matchResult_4 = 1;
                }
            }
            else {
                matchResult_4 = 1;
            }
            switch (matchResult_4) {
                case 0:
                    return spec_2;
                default:
                    return undefined;
            }
        }, toList_1(childDefs));
        place(fold((acc, tupledArg_5) => {
            const name_9 = tupledArg_5[0];
            const matchValue_7 = specOf(model$0027_3, name_9);
            let matchResult_5, spec_3;
            if (matchValue_7 != null) {
                const copyOfStruct_2 = matchValue_7;
                if (copyOfStruct_2.tag === 0) {
                    matchResult_5 = 0;
                    spec_3 = copyOfStruct_2.fields[0];
                }
                else {
                    matchResult_5 = 1;
                }
            }
            else {
                matchResult_5 = 1;
            }
            switch (matchResult_5) {
                case 0:
                    return add(name_9, spec_3.Expression, acc);
                default:
                    return acc;
            }
        }, empty({
            Compare: (x_4, y_5) => (compare(x_4, y_5) | 0),
        }), toList_1(childDefs)), specs);
        dispatch(Msg.ClosePopup);
    }, (model$0027_4) => exists_2((tupledArg_6) => {
        const matchValue_8 = specOf(model$0027_4, tupledArg_6[0]);
        let matchResult_6;
        if (matchValue_8 != null) {
            if (matchValue_8.tag === 0) {
                matchResult_6 = 0;
            }
            else {
                matchResult_6 = 1;
            }
        }
        else {
            matchResult_6 = 1;
        }
        switch (matchResult_6) {
            case 0:
                return false;
            default:
                return true;
        }
    }, toList_1(childDefs)), empty_2(), dispatch);
}

function makeSlotsField(model, comp, dispatch) {
    let children_24, children_22, children_26;
    const sheetParamsSlots = getParamSlots(comp);
    if (isEmpty_1(sheetParamsSlots)) {
        return defaultOf();
    }
    else {
        const children_28 = [react.createElement("label", {
            className: "label",
        }, "Components on this sheet using them"), react.createElement("br", {}), table_10(ofArray([TableOption.IsBordered, TableOption.IsNarrow, TableOption.IsStriped]), ofArray([(children_24 = [(children_22 = [react.createElement("th", {}, "Component"), react.createElement("th", {}, "Expression"), react.createElement("th", {}, "Constraint")], react.createElement("tr", {}, ...children_22))], react.createElement("thead", {}, ...children_24)), (children_26 = map((tupledArg) => {
            let option_1, children_6, children_8, props_12, children_10;
            const slot = tupledArg[0];
            const symbol = tryFind_1(slot.CompId, model.Sheet.Wire.Symbol.Symbols);
            const name = (symbol == null) ? "[Nonexistent]" : symbol.Component.Label;
            const constraints = defaultArg((option_1 = symbol, (option_1 != null) ? constraintsFor(slot.CompSlot, option_1.Component.Type) : undefined), empty_2());
            const children_12 = [(children_6 = [react.createElement("b", {}, name), react.createElement("br", {}), slotFieldName(slot.CompSlot)], react.createElement("td", {}, ...children_6)), (children_8 = [renderParamExpression(tupledArg[1].Expression, 0)], react.createElement("td", {}, ...children_8)), (props_12 = [new HTMLAttr(/* Class */ 65, ["tooltip has-tooltip-left"]), dataTooltip(StringModule_Concat("\n", map((constraint$0027_1) => {
                let err_2;
                if (constraint$0027_1.tag === 0) {
                    err_2 = constraint$0027_1.fields[1];
                }
                else {
                    err_2 = constraint$0027_1.fields[1];
                }
                return err_2;
            }, constraints)))], (children_10 = map((constraint$0027) => {
                if (constraint$0027.tag === 0) {
                    const children_2 = ["Min: " + renderParamExpression(constraint$0027.fields[0], 0)];
                    return react.createElement("div", {}, ...children_2);
                }
                else {
                    const children = ["Max: " + renderParamExpression(constraint$0027.fields[0], 0)];
                    return react.createElement("div", {}, ...children);
                }
            }, constraints), react.createElement("td", keyValueList(props_12, 1), ...children_10)))];
            return react.createElement("tr", {}, ...children_12);
        }, toList_1(sheetParamsSlots)), react.createElement("tbody", {}, ...children_26))]))];
        return react.createElement("div", {
            className: "component-slots",
        }, ...children_28);
    }
}

/**
 * The open SHEET's properties: what it declares, and which components on it use those.
 * Only ever drawn where no single component is selected - a selected component shows its own
 * properties instead - so there is no case here for one.
 */
export function viewParameters(model, dispatch) {
    const matchValue = model.CurrentProj;
    if (matchValue == null) {
        return defaultOf();
    }
    else {
        const proj = matchValue;
        const sheetLdc = find((ldc) => (ldc.Name === proj.OpenFileName), proj.LoadedComponents);
        const children = [makeParamsField(model, sheetLdc, dispatch), react.createElement("br", {}), makeSlotsField(model, sheetLdc, dispatch)];
        return react.createElement("div", {}, ...children);
    }
}

/**
 * A popup asking the user to choose the top sheet, or None. It fires only when several
 * top-level sheets exist, none has been chosen, and they disagree about the parameter values
 * the opened sheet displays with - roughly once per project. It never blocks opening.
 * Cancelling records the project in Model.TopSheetChoiceDeclined and the question is not asked
 * for it again, so the popup can never nag.
 */
export function topSheetChoiceCheck(model) {
    let s_1;
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        if (contains(matchValue.ProjectPath, model.TopSheetChoiceDeclined)) {
            const proj_2 = matchValue;
            return undefined;
        }
        else if (exists_2((ldc) => ldc.IsTopSheet, matchValue.LoadedComponents)) {
            const proj_3 = matchValue;
            return undefined;
        }
        else {
            const proj_4 = matchValue;
            const ldcs = proj_4.LoadedComponents;
            const sheetName = proj_4.OpenFileName;
            const rootsContaining = rootsContaining_1(ldcs, sheetName);
            let matchResult;
            if (!isEmpty(rootsContaining)) {
                if (isEmpty(tail(rootsContaining))) {
                    matchResult = 0;
                }
                else if (length(List_distinct(map((root) => map_2((_arg, display) => shownValue(display), displayValues_1(ldcs, root, sheetName)), rootsContaining), {
                    Equals: (x, y) => x.Equals(y),
                    GetHashCode: (x) => (safeHash(x) | 0),
                })) <= 1) {
                    matchResult = 1;
                }
                else {
                    matchResult = 2;
                }
            }
            else {
                matchResult = 0;
            }
            switch (matchResult) {
                case 0:
                    return undefined;
                case 1:
                    return undefined;
                default: {
                    const decline = (dispatch) => {
                        dispatch(new Msg(/* UpdateModel */ 41, [Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, topSheetChoiceDeclined_)((set$) => add_1(proj_4.ProjectPath, set$))]));
                        dispatch(Msg.ClosePopup);
                    };
                    let body;
                    const children = [concat("Sheet ", sheetName, " is used in more than one top-level design, and its property values differ between them. Choose which design the editor should display it as part of."), react.createElement("br", {}), react.createElement("br", {}), (s_1 = "You can change this at any time by right-clicking a sheet in the Sheets menu and choosing \'Set as top\'. Cancelling shows the sheet with its default property values.", s_1)];
                    body = react.createElement("div", {}, ...children);
                    return (dispatch_3) => ((model_2) => buildPopup("Choose the top sheet", (_arg_4, _arg_5) => body, (dispatch_1, _arg_1) => level(singleton(new Level_Option(/* Props */ 0, [singleton(["style", {
                        width: "100%",
                    }])])), ofArray([left(empty_2(), empty_2()), right(empty_2(), append(singleton(item(empty_2(), singleton(button(ofArray([new Option_2(/* Color */ 0, [Color_IColor.IsLight]), new Option_2(/* OnClick */ 18, [(_arg_3) => {
                        decline(dispatch_1);
                    }])]), singleton("Not now"))))), map((root_1) => item(empty_2(), singleton(button(ofArray([new Option_2(/* Color */ 0, [Color_IColor.IsPrimary]), new Option_2(/* OnClick */ 18, [(_arg_2) => {
                        dispatch_1(new Msg(/* UpdateModel */ 41, [(model_1) => setTopSheetState(root_1, model_1)]));
                        dispatch_1(Msg.ClosePopup);
                        dispatch_1(Msg.PropagateParameters);
                    }])]), singleton(root_1)))), rootsContaining)))])), (dispatch_2, _arg_6) => {
                        decline(dispatch_2);
                    }, empty_2(), dispatch_3, model_2));
                }
            }
        }
    }
    else {
        return undefined;
    }
}

